import "./App.css";
import React, { useEffect, useState } from "react";
import {
  Route,
  Switch,
  BrowserRouter,
  useHistory,
  create,
  useLocation,
  Router,
} from "react-router-dom";
import { createBrowserHistory } from "history";

import Home from "./pages/Home";
import Login from "./components/auth/Login";
import SignUp from "./components/auth/SignUp";
import Navbar from "./components/Home/Navbar";
import Footer from "./components/Home/Footer";
import Blog from "./components/Blog/Blog";
import Loyalty from "./components/modules/Loyalty";
import Point_of_sale from "./components/modules/Point_of_sale";
import Ecommerce from "./components/modules/Ecommerce";
import Payments from "./components/modules/Payments";
import Payment_in_person from "./components/modules/Payment_in_person";
import Accouting_ERPs from "./components/modules/Accouting_ERPs";
import Payments_on_website from "./components/modules/Payments_on_website";
import Resellers_program from "./components/modules/Resellers_program";
import Inventory_managment from "./components/modules/Inventory_managment";
import Developers from "./components/modules/Developers";
import Products from "./components/modules/Products";
import About_us from "./components/modules/About_us";
import Purchase from "./components/modules/Purchase";
import Help_center from "./components/modules/Help_center";
import Contact_sales from "./components/modules/Contact_sales";
import Retail from "./components/modules/Retail";
import Payments_risk_manage from "./components/modules/Payments_risk_manage";
import Invu_expert from "./components/modules/Invu_expert";
import Payment_on_computer from "./components/modules/Payment_on_computer";
import Large_business from "./components/modules/Large_business";
import Food_and_beverage from "./components/modules/Food_and_beverage";
import Professional_services from "./components/modules/Professional_services";
import Payment_platform from "./components/modules/Payment_platform";
import Transfers from "./components/modules/Transfers";
import Guides from "./components/modules/Guides";
import Health_and_fitness from "./components/modules/Health_and_fitness";
import Beauty_professionals from "./components/modules/Beauty_professionals";
import Coffee_shop from "./components/modules/Coffee_shop";
import Processor_payment from "./components/modules/Processor_payment";
import Business_types_general from "./components/modules/Business_types_general";
import Product_KDS from "./components/modules/Product_KDS";
import Product_Kiosks from "./components/modules/Product_Kiosks";
import Product_Marketing from "./components/modules/Product_Marketing";
import Products_Plus from "./components/modules/Products_Plus";
import Article_blog from "./components/Articles/Article_blog";
import Resources from "./components/modules/Resources";
import PageNotFound from "./components/modules/PageNotFound";
import Hardware_details from "./components/modules/Hardware_details";
import Article_blog_one from "./components/Articles/Article_blog_one";
import Home_repair_services from "./components/modules/Home_repair_services";
import Careers_main from "./components/Careers/Careers_main";
import Careers_details from "./components/Careers/Careers_details";
import Integrations from "./components/modules/Integrations";
import Pricing from "./components/modules/Pricing";
import Switch_invu from "./components/modules/Switch_invu";
import Whats_news from "./components/modules/Whats_news";
//New modules - Business types
import Restaurants from "./components/modules/Restaurants";
import Pubs from "./components/modules/Pubs";
import Minimarkets from "./components/modules/Minimarkets";
import Butcheries from "./components/modules/Butcheries";
import Fastfood from "./components/modules/Fastfood";
import Greengrocers from "./components/modules/Greengrocers";
import Retail_overview from "./components/modules/Retail_overview";
import Clothing from "./components/modules/Clothing";
import Furniture from "./components/modules/Furniture";
import Electronics from "./components/modules/Electronics";
import Movies from "./components/modules/Movies";
import Stadiums from "./components/modules/Stadiums";
import Arcades from "./components/modules/Arcades";
import Enterteiment_general from "./components/modules/Enterteiment_general";
import Bolos from "./components/modules/Bolos";
import Electronic_invoicing from "./components/modules/Electronic_invoicing";
import Fiscal_printers from "./components/modules/Fiscal_printers";
import Dealers from "./components/modules/Dealers";
import Counters from "./components/modules/Counters";
import Delivery_platform from "./components/modules/Delivery_platform";
import Productions from "./components/modules/Productions";
import Why_invu from "./components/modules/Why_invu";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";
import { withRouter } from "react-router-dom";
import TagManager from "react-gtm-module";
import i18n from "./i18n";
import { Redirect } from "react-router";

//Blogs

import Article_accouting from "./components/Articles/Article_accouting";
import Article_DGI from "./components/Articles/Article_DGI";
import Article_pos_shops from "./components/Articles/Article_pos_shops";

import Thanks_sending from "./components/modules/Thanks_sending";
import Article_receive_payments from "./components/Articles/Article_receive_payments";
import Article_electronic_signature from "./components/Articles/Article_electronic_signature";
import Article_online_billing from "./components/Articles/Article_online_billing";
import Article_invu_processor from "./components/Articles/Article_invu_processor";
import Article_pos_restaurants from "./components/Articles/Article_pos_restaurants";
import Article_ecommerce_invu from "./components/Articles/Article_ecommerce_invu";
import Article_loyalty_invu from "./components/Articles/Article_loyalty_invu";
import Article_protect_earning from "./components/Articles/Article_protect_earning";
import Article_importance_software_loyalty from "./components/Articles/Article_importance_software_loyalty";
import Article_ecommerce_online_offline from "./components/Articles/Article_ecommerce_online_offline";
import Article_lose_matter from "./components/Articles/Article_lose_matter";
import Article_four_functions from "./components/Articles/Article_four_functions";
import Article_tips_design_web from "./components/Articles/Article_tips_design_web";
import Article_cash_flow from "./components/Articles/Article_cash_flow";
import Articles_sales_offline_online from "./components/Articles/Articles_sales_offline_online";
import Article_six_functions_pos from "./components/Articles/Article_six_functions_pos";
import Article_custom_email_solution from "./components/Articles/Article_custom_email_solution";
import Article_data_pos from "./components/Articles/Article_data_pos";
import Article_seven_tips_managment_restaurants from "./components/Articles/Article_seven_tips_management_restaurants";
import Article_online_ordering from "./components/Articles/Article_online_ordering";
import Article_marketing_restaurant from "./components/Articles/Article_marketing_restaurant";
import Article_ten_loyalty_industries from "./components/Articles/Article_ten_loyalty_industries";
import Hotel from "./components/modules/Hotel";
import Privacy_policies from "./components/modules/Privacy_policies";
import Cookie_policy from "./components/modules/Cookie_policy";
import CookiePolicy_info from "./components/modules/CookiePolicy_info";
import Demo_confirmed from "./components/modules/Demo_confirmed";
import Loyalty_program from "./components/modules/Loyalty_program";
import Article_seven_irresistible_benefits_invupos from "./components/Articles/Article_seven_irresistible_benefits_invupos";
import axios from "axios";
import LandingMX from "./pages/landingMX/LandingMX";
import Article_DGI_free_invoicer_in_panama from "./components/Articles/Article_DGI_free_invoicer_in_panama";
import Form_Contact from "./components/Home/Form_Contact";
import Demo_confirmed_external from "./components/modules/Demo_confirmed_external";
import FAQ from "./components/modules/FAQ";
import Article_nvidia_inception from "./components/Articles/Article_nvidia_inception";
import Article_restaurant_mexico_invupos from "./components/Articles/Article_restaurant_mexico_invupos";
import Article_maximizing_customer_loyalty from "./components/Articles/Article_maximizing_customer_loyalty";
import Article_alliance_with_cloudbeds from "./components/Articles/Article_alliance_with_cloudbeds";
import Article_gastronomic_future from "./components/Articles/Article_gastronomic_future";
import Article_management_inventory_hotel from "./components/Articles/Article_management_inventory_hotel";

// MX LANDING
import NavbarMX from "./pages/landingMX/NavbarMX/NavbarMX";
import FooterMX from "./pages/landingMX/FooterMX/FooterMX";
import NavbarVN from "./pages/landingVN/NavbarVN/NavbarVN";
import LandingVN from "./pages/landingVN/LandingVN";
import FooterVN from "./pages/landingVN/FooterVN/FooterVN";
import Article_in_the_cloud from "./components/Articles/Article_in_the_cloud";
import NavbarSV from "./pages/landingSV/NavbarSV/NavbarSV";
import LandingSV from "./pages/landingSV/LandingSV";
import FooterSV from "./pages/landingSV/FooterSV/FooterSV";
import Article_exploring_restaurant_systems from "./components/Articles/Article_exploring_restaurant_systems";
import BlogVN from "./components/Blog/BlogVN";
import BlogMX from "./components/Blog/BlogMX";
import Article_software_for_restaurants_mx from "./components/Articles/Article_softwarepos_for_restaurants_mx";
import Article_software_for_restaurants_sv from "./components/Articles/Article_softwarepos_for_restaurants_sv";
import BlogSV from "./components/Blog/BlogSV";
import Article_steps_to_implement_electronic_invoicing from "./components/Articles/Article_steps_to_implement_electronic_invoicing";
import Article_how_to_integrate_your_pos_system from "./components/Articles/Article_how_to_integrate_your_pos_system";
import Article_system_pos_and_delivery_platform_vn from "./components/Articles/Article_system_pos_and_delivery_platform_vn";
import NavbarCR from "./pages/landingCR/NavbarCR/NavbarCR";
import LandingCR from "./pages/landingCR/LandingCR";
import FooterCR from "./pages/landingCR/FooterCR/FooterCR";
import NavbarCL from "./pages/landingCL/NavbarCL/NavbarCL";
import LandingCL from "./pages/landingCL/LandingCL";
import FooterCL from "./pages/landingCL/FooterCL/FooterCL";
import Article_best_softwarepos_for_retaurants_in_panama from "./components/Articles/Article_best_softwarepos_for_restaurants_in_panama";
import Article_software_for_restaurants_cr from "./components/Articles/Article_software_for_restaurants_cr";
import BlogCR from "./components/Blog/BlogCR";
import BlogCL from "./components/Blog/BlogCL";
import Article_software_for_restaurants_cl from "./components/Articles/Article_software_for_restaurants_cl";
import Article_optimize_your_pos_system_for_unmatched_service from "./components/Articles/Article_optimize_your_pos_system_for_unmatched_service";
import Article_optimizing_the_supply_chain from "./components/Articles/Article_optimizing_the_supply_chain";
import Article_five_reasons_to_have_pos_cl from "./components/Articles/Article_five_reasons_to_have_pos_cl";
import Article_boosting_profitability_restaurant_pos_vn from "./components/Articles/Article_boosting_profitability_restaurant_pos_vn";
import Article_simplify_billing_and_payment_process from "./components/Articles/Article_simplify_billing_and_payment_process";
import Article_why_choose_cloud_pos_system from "./components/Articles/Article_why_choose_cloud_pos_system";
import Article_custom_pos_system_sv from "./components/Articles/Article_custom_pos_system_sv";
import Article_how_to_improve_customer_experience_mx from "./components/Articles/Article_how_to_improve_customer_experience_mx";
import Article_strategies_to_increase_sales_all from "./components/Articles/Article_strategies_to_increase_sales_all";
import Article_the_future_of_coffee from "./components/Articles/Article_the_future_of_coffee";
import Article_how_kds_systems_streamline from "./components/Articles/Article_how_kds_systems_streamline";
import Article_tips_and_tricks_from_a_chef from "./components/Articles/Article_tips_and_tricks_from_a_chef";
import Article_five_reasons_why_restaurant_needs_modern_web from "./components/Articles/Article_five_reasons_why_restaurant_needs_modern_web";
import Article_how_to_improve_the_customer_experience_in_bar from "./components/Articles/Article_how_to_improve_the_customer_experience_in_bar";


import { Select, MenuItem, FormControl, InputLabel, ListItemText, ListItemIcon } from '@mui/material'; // Importa los componentes necesarios de Material-UI
import { height } from "@mui/system";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import Article_how_pos_system_can_help_boost_hotel_rest_sales from "./components/Articles/Article_how_pos_system_can_help_boost_hotel_rest_sales";
import Article_best_utensils_for_a_chef from "./components/Articles/Article_best_utensils_for_a_chef";
import Referrals from "./components/modules/Referrals";
import Article_importance_pos_system_event_management from "./components/Articles/Article_importance_pos_system_event_management";
import Article_the_benefits_of_online_delivery from "./components/Articles/Article_the_benefits_of_online_delivery";
import Article_guide_for_restaurants_in_panama from "./components/Articles/Article_guide_for_restaurants_in_panama";
import Barber from "./components/modules/Barber";
import Tatto_studios from "./components/modules/Tatto_studios";
import Dayspa from "./components/modules/Dayspa";
import Professional_services_module from "./components/modules/Professional_services_module";
import Article_how_an_effective_pos from "./components/Articles/Article_how_an_effective_pos";
import Theater from "./components/modules/Theater";
import Festival from "./components/modules/Festival";
import Food_truck from "./components/modules/Food_truck";
import Franchises from "./components/modules/Franchises";
import Cocina_fantasma from "./components/modules/Cocina_fantasma";
import Article_complete_guide_for_your_coffeeshop from "./components/Articles/Article_complete_guide_for_your_coffeeshop";
import Article_marketing_digital_for_barbers from "./components/Articles/Article_marketing_digital_for_barbers";
import Article_pos_system_tattoo_studio from "./components/Articles/Article_pos_system_tattoo_studio";
import Article_hero_integration from "./components/Articles/Article_hero_integration";
import Article_bestpos_system_spas_beautysalons from "./components/Articles/Article_bestpos_system_spas_beautysalons";
import Resources_gallery from "./components/modules/Resources_gallery";
import Hardware from "./components/modules/pressresources/Hardware";
import Vector_system from './components/modules/pressresources/Vector_system';
import Three_dimension from './components/modules/pressresources/Three_dimension';
import Kds from './components/modules/pressresources/Kds';
import Article_choose_the_best_system_craft_brewery from "./components/Articles/Article_choose_the_best_system_craft_brewery";
import Article_gift_cards_beatuy_salons from "./components/Articles/Article_gift_cards_beatuy_salons";
import Logos from "./components/modules/pressresources/Logos";
import Demo_figma from "./components/modules/Demo_figma";
import Article_food_truck from "./components/Articles/Article_food_truck";
import Article_abastur_mexico from "./components/Articles/Article_abastur_mexico";
import Case_studies from "./components/modules/Case_studies";
import Article_digital_wallets_for_restaurants from "./components/Articles/Article_digital_wallets_for_restaurants";
import Article_implementation_pos_software_in_rest_salvador from "./components/Articles/Article_implementation_pos_software_in_rest_salvador";
import Article_how_pos_system_helps_to_improve_staff_productivity_in_salvadoran_commerce from "./components/Articles/Article_how_pos_system_helps_to_improve_staff_productivity_in_salvadoran_commerce";
import Article_the_digitization_of_commmerce_in_cl from "./components/Articles/Article_the_digitization_of_commmerce_in_cl";
import Article_benefits_of_integrating_pos_programs_in_cr from "./components/Articles/Article_benefits_of_integrating_pos_programs_in_cr";
import Article_five_reasons_why_rest_in_panama_migrating from "./components/Articles/Article_five_reasons_why_rest_in_panama_migrating";
import Article_five_reasons_why_rest_in_mexico_migrating from "./components/Articles/Article_five_reasons_why_rest_in_mexico_migrating";
import Article_how_pos_systems_make_inventory_and_sales_easier from "./components/Articles/Article_how_pos_systems_make_inventory_and_sales_easier";
import Article_Why_are_restaurants_in_mx_adopting_cloud_pos from "./components/Articles/Article_Why_are_restaurants_in_mx_adopting_cloud_pos";
import Article_improve_the_management_of_your_rest_in_cl from "./components/Articles/Article_improve_the_management_of_your_rest_in_cl";
import Article_how_cloud_pos_system_facilities_rest_in_cr from "./components/Articles/Article_how_cloud_pos_system_facilities_rest_in_cr";
import Article_how_pos_system_helps_manage_costs_in_rest_vn from "./components/Articles/Article_how_pos_system_helps_manage_costs_in_rest_vn";
import Article_seven_ways_to_boost_hotel_revenues from "./components/Articles/Article_seven_ways_to_boost_hotel_revenues";
import Article_increase_revenue_with_invupos_delivery_integrations from "./components/Articles/Article_increase_revenue_with_invupos_delivery_integrations";
import Article_the_ideal_software_for_rest_in_sv from "./components/Articles/Article_the_ideal_software_for_rest_in_sv";
import Article_integrations_for_rest_in_sv from "./components/Articles/Article_integrations_for_rest_in_sv";
import Article_the_digital_revolution_for_rest_in_cl from "./components/Articles/Article_the_digital_revolution_for_rest_in_cl";
import Article_key_to_a_successful_new_year from "./components/Articles/Article_key_to_a_successful_new_year";
import Horeca from "./components/modules/Horeca";
import Article_increase_your_sale_with_invu_in_sv from "./components/Articles/Article_increase_your_sale_with_invu_in_sv";
import Article_invupos_the_software_chosen_by_imin_for_the_nrf from "./components/Articles/Article_invupos_the_software_chosen_by_imin_for_the_nrf";
import Article_optimize_your_online_sales from "./components/Articles/Article_optimize_your_online_sales";
import Article_how_loyalty_programs_can_increase_your_sales_mx from "./components/Articles/Article_how_loyalty_programs_can_increase_your_sales_mx";
import Thanks_sending_pipedrive from "./components/modules/Thanks_sending_pipedrive";
import Contact_pipedrive from "./components/Home/Contact_pipedrive";
import Test_button_pd from "./components/Home/Test_button_pd";
import Button_test_component from "./components/Home/Button_test_component";
import Article_the_importance_of_a_pos_systems_for_controlling_orders from "./components/Articles/Article_the_importance_of_a_pos_systems_for_controlling_orders";
import Article_the_evolution_of_pos_systems_in_colombia from "./components/Articles/Article_the_evolution_of_pos_systems_in_colombia";
import Article_how_a_revolutionary_POS_system_operates_foodtrucks from "./components/Articles/Article_how_a_revolutionary_POS_system_operates_foodtrucks";
import Article_rest_automations_how_to_optimize_orders_inventory_and_payments_with_technology from "./components/Articles/ Article_rest_automations_how_to_optimize_orders_inventory_and_payments_with_technology";
import Article_electronic_billing_in_el_salvador from "./components/Articles/Article_electronic_billing_in_el_salvador";
import Artilcle_optimize_your_food_truck_in_colombia from "./components/Articles/Artilcle_optimize_your_food_truck_in_colombia";
import Article_five_ways_a_cloud_pos_improves_the_customer_experience from "./components/Articles/Article_five_ways_a_cloud_pos_improves_the_customer_experience";
import Testblog from "./components/modules/Testblog";
import Article_make_your_restaurant_in_guatemala_sell_more_with_a_modern_POS from "./components/Articles/Article_make_your_restaurant_in_guatemala_sell_more_with_a_modern_POS";
import NavbarGT from "./pages/landingGT/NavbarGT/NavbarGT";
import LandingGT from "./pages/landingGT/LandingGT";
import FooterGT from "./pages/landingGT/FooterGT/FooterGT";
import BlogGT from "./components/Blog/BlogGT";
import Article_KDS_incorporated_with_POS from "./components/Articles/Article_KDS_incorporated_with_POS";
import Article_how_to_avoid_errors_in_delivery_orders_with_a_smart_POS from "./components/Articles/Article_how_to_avoid_errors_in_delivery_orders_with_a_smart_POS";
import NavbarRD from "./pages/landingRD/NavbarRD/NavbarRD";
import LandingRD from "./pages/landingRD/LandingRD";
import FooterRD from "./pages/landingRD/FooterRD/FooterRD";
import Article_choose_the_best_electronic_invoicing_system_for_your_business_in_panama from "./components/Articles/Article_choose_the_best_electronic_invoicing_system_for_your_business_in_panama";
import Article_benefits_of_a_POS_system_for_retail_inventory_management_in_colombia from "./components/Articles/Article_benefits_of_a_POS_system_for_retail_inventory_management_in_colombia";
import Article_upgrading_your_pos_syst_is_key_to_key_to_the_success_of_your_rest_cr from "./components/Articles/Article_upgrading_your_pos_syst_is_key_to_key_to_the_success_of_your_rest_cr";
import Article_how_an_agile_POS_improves_improves_rush_hour_service from "./components/Articles/Article_how_an_agile_POS_improves_improves_rush_hour_service";
import Software_release from "./components/modules/Software_release";
import Release_notes_page from "./components/modules/Release_notes_page";
import Article_more_tips_less_problems from "./components/Articles/Article_more_tips_less_problems";
import Article_POS_system_for_hotels_in_costa_rica from "./components/Articles/Article_POS_system_for_hotels_in_costa_rica";
import Article_invu_reconocimientos from "./components/Articles/Article_invu_reconocimientos";
import Article_the_best_point_of_sale_system_for_supermarkets_in_el_salvador from "./components/Articles/Article_the_best_point_of_sale_system_for_supermarkets_in_el_salvador";
import NavbarUSA from "./pages/landingUSA/NavbarUSA/NavbarUSA";
import LandingUSA from "./pages/landingUSA/LandingUSA";
import FooterUSA from "./pages/landingUSA/FooterUSA/FooterUSA";
import NavbarTRI from "./pages/landingTRI/NavbarTRI/NavbarTRI";
import LandingTRI from "./pages/landingTRI/LandingTRI";
import FooterTRI from "./pages/landingTRI/FooterTRI/FooterTRI";
import Article_invu_pos_novedades from "./components/Articles/Article_invu_pos_novedades";
import Article_checklist_to_determine_if_your_restaurant_needs_to_upgrade_its_POS_system from "./components/Articles/Article_checklist_to_determine_if_your_restaurant_needs_to_upgrade_its_POS_system";
import BlogRD from "./components/Blog/BlogRD";
import Article_why_are_businesses_in_mx_betting_on_loyalty_programs_digital from "./components/Articles/Article_why_are_businesses_in_mx_betting_on_loyalty_programs_digital";
import Contact_form_zoho1 from "./components/Home/Contact_form_zoho1";
import Contact_form_zoho2 from "./components/Home/Contact_form_zoho2";
import Thanks_sending_zoho from "./components/modules/Thanks_sending_zoho";
import Article_loyalty_in_the_digital_age from "./components/Articles/Article_loyalty_in_the_digital_age";
import Modal_contact_zoho from "./components/Home/Modal_contact_zoho";
import Article_KDS_system_worth_investing_in from "./components/Articles/Article_KDS_system_worth_investing_in";
import Article_electronic_invoicing_in_the_dominican_republic from "./components/Articles/Article_electronic_invoicing_in_the_dominican_republic";
import Article_loyalty_boosts_your_business_in_costa_rica from "./components/Articles/Article_loyalty_boosts_your_business_in_costa_rica";
import Article_best_POS_software_for_restaurants_rd from "./components/Articles/Article_best_POS_software_for_restaurants_rd";
import Test_manual_de_uso from "./components/modules/Test_manual_de_uso";
import Article_avoid_fines_and_penalties_sv from "./components/Articles/Article_avoid_fines_and_penalties_sv";
import Article_delivery_promociones_lealtad_vn from "./components/Articles/Article_delivery_promociones_lealtad_vn";
import Help_center_test from "./components/modules/Help_center_test";
import InvuApp from "./components/modules/InvuApp";
import PanelAdmin from "./components/modules/PanelAdmin";
import Menu_su_categorias from "./components/Help_center_categories/InvuApp/Menu_su_categorias";
import Article_errores_comunes_en_la_gestion_de_cafeterias from "./components/Articles/Article_errores_comunes_en_la_gestion_de_cafeterias";
import Release_notes from "./components/modules/Release_notes";
import Abril2025_actualizaciones_de_producto from "./components/Help_center_categories/SoftwareRelease/InvuPOS3/Abril2025_actualizaciones_de_producto";
import Abril2025_actualizaciones_de_admin from "./components/Help_center_categories/SoftwareRelease/Admin/Abril2025_actualizaciones_de_admin";
import Abril2025_nuevos_reportes_agregados from "./components/Help_center_categories/SoftwareRelease/Admin/Abril2025_nuevos_reportes_agregados";
import Article_control_total_de_tus_sucursales_en_mx from "./components/Articles/Article_control_total_de_tus_sucursales_en_mx";
import Article_complete_control_of_your_branches_in_panama_with_invu_POS from "./components/Articles/Article_complete_control_of_your_branches_in_panama_with_invu_POS";
import Manual_ver_info_del_cliente_en_pedidos_de_clau_anonimo from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_ver_info_del_cliente_en_pedidos_de_clau_anonimo";
import Manual_creacion_de_grupos_y_unidades_de_cobro from "./components/Help_center_categories/InvuManuales/Yappy/Manual_creacion_de_grupos_y_unidades_de_cobro";
import Manual_creacion_de_boton_de_pago_yappy from "./components/Help_center_categories/InvuManuales/Yappy/Manual_creacion_de_boton_de_pago_yappy";
import Manual_generacion_de_credenciales from "./components/Help_center_categories/InvuManuales/Yappy/Manual_generacion_de_credenciales";
import Manual_generacion_de_qr from "./components/Help_center_categories/InvuManuales/Yappy/Manual_generacion_de_qr";
import Manual_tipo_de_orden from "./components/Help_center_categories/InvuManuales/Deliverect/Manual_tipo_de_orden";
import Manual_configuracion_de_item from "./components/Help_center_categories/InvuManuales/Deliverect/Manual_configuracion_de_item";
import Manual_creacion_de_tipo_de_pago from "./components/Help_center_categories/InvuManuales/Deliverect/Manual_creacion_de_tipo_de_pago";
import Manual_activacion_de_caja_para_pedidos from "./components/Help_center_categories/InvuManuales/Deliverect/Manual_activacion_de_caja_para_pedidos";
import Manual_tipo_de_pago_cloudbeds from "./components/Help_center_categories/InvuManuales/Cloudbeds/Manual_tipo_de_pago_cloudbeds";
import Manual_conexion_de_cuenta from "./components/Help_center_categories/InvuManuales/Marketman/Manual_conexion_de_cuenta";
import Manual_tipo_de_orden_cloudbeds from "./components/Help_center_categories/InvuManuales/Cloudbeds/Manual_tipo_de_orden_cloudbeds";
import Manual_proveedores_producto_por_proveedor from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_proveedores_producto_por_proveedor";
import Manual_admin_abono_a_cuenta_personal_clientes from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_admin_abono_a_cuenta_personal_clientes";
import Manual_requisiciones_solicitar_una_requisicion from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_requisiciones_solicitar_una_requisicion";
import Manual_requisiciones_enviar_una_requisicion from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_requisiciones_enviar_una_requisicion";
import Manual_ordenes_de_compra_crear_orden_de_compra from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_ordenes_de_compra_crear_orden_de_compra";
import Article_why_your_kitchen_in_colombia_needs_a_KDS from "./components/Articles/Article_why_your_kitchen_in_colombia_needs_a_KDS";
import Manual_invukds_configuracion_pantallas from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_invukds_configuracion_pantallas";
import Manual_invuKDS_configuracion_agrupacion_flujo from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_invukds_configuracion_agrupacion_flujo";
import Manual_invuKDS_comandas from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_invukds_comandas";
import Manual_invukds_configuraciones_general from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_invukds_configuraciones_general";
import Manual_invuPOS_pagos_automaticos from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_invupos_pagos_automaticos";
import Manual_invukds_configuraciones_estaciones from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_invukds_configuraciones_estaciones";
import Article_invu_POS_conquers_latin_america_and_the_2025_awards from "./components/Articles/Article_invu_POS_conquers_latin_america_and_the_2025_awards";
import Manual_orden_de_subcategorias from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_orden_de_subcategorias";
import Manual_menu_promociones from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_menu_promociones";
import Manual_menu_comisiones from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_menu_comisiones";
import Manual_menu_categoria from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_menu_categoria";
import Manual_menu_modificadores_opciones from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_menu_modificadores_opciones";
import Manual_menu_items from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_menu_items";
import Manual_menu_subcategorias from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_menu_subcategorias";
import Manual_admin_crear_clientes from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_admin_crear_clientes";
import Manual_admin_plano_de_mesa from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_admin_plano_de_mesa";
import Manual_proveedores_creacion_proveedor_interno from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_proveedores_creacion_proveedor_interno";
import Manual_ordenes_compra_revertir_parcialmente from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_ordenes_compra_revertir_parcialmente";
import Manual_ordenes_compra_revertir_orden_completa from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_ordenes_compra_revertir_orden_completa";
import Manual_admin_roles_ipad from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_admin_roles_ipad";
import Manual_admin_descuentos from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_admin_descuentos";
import Manual_ordenes_compra_compra_rapida from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_ordenes_compra_compra_rapida";
import Manual_orden_opciones_modificadores from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_orden_opciones_modificadores";
import Manual_orden_categorias from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_orden_categorias";
import Manual_orden_menu from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_orden_menu";
import Manual_orden_modificadores from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_orden_modificadores";
import Manual_admin_caja_registradora from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_admin_caja_registradora";
import Manual_menu_modificadores_precios_multiples from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_menu_modificadores_precios_multiples";
import Manual_menu_item_precios_multiples from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_menu_item_precios_multiples";
import Manual_admin_tiempos_comida from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_admin_tiempos_comida";
import Manual_proveedores_gestionar_proveedores from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_proveedores_gestionar_proveedores";
import Manual_inventario_recetas from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_inventario_recetas";
import Manual_inventario_mermas from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_inventario_mermas";
import Manual_inventario_tipos_mermas from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_inventario_tipos_mermas";
import Article_the_key_to_scale_your_commerce_in_sv from "./components/Articles/Article_the_key_to_scale_your_commerce_in_sv";
import FAQ_business_types from "./components/modules/FAQ_business_types";
import Manual_inventario_conteo_inventario from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_inventario_conteo_inventario";
import Manual_inventario_receta_modificadores from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_inventario_receta_modificadores";
import Manual_inventario_ajuste_subreceta from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_inventario_ajuste_subreceta";
import Manual_inventario_ajuste_inventario from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_inventario_ajuste_inventario";
import Manual_inventario_subrecetas from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_inventario_subrecetas";
import Manual_inventario_ingredientes from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_inventario_ingredientes";
import Manual_inventario_categoria_producto from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_inventario_categoria_producto";
import Manual_inventario_categoria_producto_dos from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_inventario_categoria_producto_dos";
import Manual_admin_comandas from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_admin_comandas";
import Manual_admin_roles_administrador from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_admin_roles_administrador";
import Manual_admin_tipos_pago from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_admin_tipos_pago";
import Manual_admin_propinas from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_admin_propinas";
import Manual_admin_tipo_orden from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_admin_tipo_orden";
import Manual_admin_impuestos from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_admin_impuestos";
import Manual_admin_usuario_administrativo from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_admin_usuario_administrativo";
import Manual_admin_empleados from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_admin_empleados";
import Manual_admin_faceid_empleados from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_admin_faceid_empleados";
import Manual_invupos_reimpresion_ordenes from "./components/Help_center_categories/InvuManuales/InvuClau/Manual_invupos_reimpresion_ordenes";
import Guias_clau from "./components/modules/Guias_clau";
import Aplicacion_invupos_guias from "./components/modules/Aplicacion_invupos_guias";
import Integraciones_guias from "./components/modules/Integraciones_guias";
import Article_eres_dueño_o_gerente_de_hotel from "./components/Articles/Article_eres_dueño_o_gerente_de_hotel";
import Article_como_un_buen_sistema_POS_impulsa_el_crecimiento_de_tu_negocio_en_cr from "./components/Articles/Article_como_un_buen_sistema_POS_impulsa_el_crecimiento_de_tu_negocio_en_cr";
import Manual_digifact_descarga_reporte from "./components/Help_center_categories/InvuManuales/Electronic_billing/Manual_digifact_descarga_reporte";
import Manual_cliente_extranjero_sv from "./components/Help_center_categories/InvuManuales/Electronic_billing/Manual_cliente_extranjero_sv";
import Manual_cliente_juridico_sv from "./components/Help_center_categories/InvuManuales/Electronic_billing/Manual_cliente_juridico_sv";
import Manual_cliente_natural_sv from "./components/Help_center_categories/InvuManuales/Electronic_billing/Manual_cliente_natural_sv";
import Manual_cliente_natural_gt from "./components/Help_center_categories/InvuManuales/Electronic_billing/Manual_cliente_natural_gt";
import Guias_facturacion_electronica from "./components/modules/Guias_facturacion_electronica";
import ManualsRenderNew from "./components/modules/ManualsRenderNew";
import Article_delivery_takeout_or_dine_in from "./components/Articles/Article_delivery_takeout_or_dine_in";
import Article_speed_and_accuracy_the_secret_of_restaurants_in_mx from "./components/Articles/Article_speed_and_accuracy_the_secret_of_restaurants_in_mx";
import Article_loyalty_sales_strategies_co from "./components/Articles/Article_loyalty_sales_strategies_co";
import Article_como_invu_POS_esta_transformando_la_experiencia_en_cafeterias_en_panama from "./components/Articles/Article_como_invu_POS_esta_transformando_la_experiencia_en_cafeterias_en_panama";
import Article_invupos_anuncia_participacion_abastur_2025 from "./components/Articles/Article_invupos_anuncia_participacion_abastur_2025";
import Ferias from "./components/modules/Ferias";
import Article_integraciones_que_potencian_tu_negocio_en_el_salvador from "./components/Articles/Article_integraciones_que_potencian_tu_negocio_en_el_salvador";
import Article_invupos_participa_en_el_abastur_2025 from "./components/Articles/Article_invupos_participa_en_el_abastur_2025";
import Pagosflexibles from "./components/modules/Pagosflexibles";
import Delivery from "./components/modules/Delivery";
import Article_hoteles_inteligentes_en_republica_dominicana_como_un_pos_transforma_la_experiencia_del_huesped from "./components/Articles/Article_hoteles_inteligentes_en_republica_dominicana_como_un_pos_transforma_la_experiencia_del_huesped";
import Article_5_formas_en_que_la_facturacion_digital_con_invu_pos_mantiene_tu_negocio_en_orden from "./components/Articles/Article_5_formas_en_que_la_facturacion_digital_con_invu_pos_mantiene_tu_negocio_en_orden";
import Article_Delivery_en_Colombia_como_los_restaurantes_pueden_gestionarlo_de_forma_mas_eficiente_con_Invu_POS from "./components/Articles/Article_Delivery_en_Colombia_como_los_restaurantes_pueden_gestionarlo_de_forma_mas_eficiente_con_Invu_POS";
import Modal_new from "./components/Home/Modal_new";
import Article_como_transformar_tu_restaurante_en_un_ecommerce_rentable_con_invu from "./components/Articles/Article_como_transformar_tu_restaurante_en_un_ecommerce_rentable_con_invu";
import Article_Integraciones_que_impulsan_tu_restaurante_delivery_bancos_y_ecommerce_desde_un_solo_sistema from "./components/Articles/Article_Integraciones_que_impulsan_tu_restaurante_delivery_bancos_y_ecommerce_desde_un_solo_sistema";
import Ecommerce_new from "./components/modules/Ecommerce_new";
import Article_diez_formas_en_que_un_buen_sistema_POS_transforma_la_eficiencia_de_tu_restaurante from "./components/Articles/Article_diez_formas_en_que_un_buen_sistema_POS_transforma_la_eficiencia_de_tu_restaurante";
import Manual_funciones_configuracion_clau_admin from "./components/Help_center_categories/InvuManuales/Clau/Manual_funciones_configuracion_clau_admin";
import Manual_funciones_clientes_clau_admin from "./components/Help_center_categories/InvuManuales/Clau/Manual_funciones_clientes_clau_admin";
import Manual_funciones_pos_clau_admin from "./components/Help_center_categories/InvuManuales/Clau/Manual_funciones_pos_clau_admin";
import Manual_funciones_productos_clau_admin from "./components/Help_center_categories/InvuManuales/Clau/Manual_funciones_productos_clau_admin";
import Manual_funciones_ordenes_clau_admin from "./components/Help_center_categories/InvuManuales/Clau/Manual_funciones_ordenes_clau_admin";
import Manual_canje_regalos_clau_invu from "./components/Help_center_categories/InvuManuales/Clau/Manual_canje_regalos_clau_invu";
import Manual_cambiar_status_clau_invu from "./components/Help_center_categories/InvuManuales/Clau/Manual_cambiar_status_clau_invu";
import Manual_flujo_orden_clau_invu from "./components/Help_center_categories/InvuManuales/Clau/Manual_flujo_orden_clau_invu";
import Manual_canjear_beneficios_clau_invu from "./components/Help_center_categories/InvuManuales/Clau/Manual_canjear_beneficios_clau_invu";
import Manual_buscar_clientes_registrados_clau_invu from "./components/Help_center_categories/InvuManuales/Clau/Manual_buscar_clientes_registrados_clau_invu";
import Manual_solicitar_uber_direct_invu from "./components/Help_center_categories/InvuManuales/Clau/Manual_solicitar_uber_direct_invu";
import Manual_solicitar_delivery_uber_direct_ecommerce from "./components/Help_center_categories/InvuManuales/Clau/Manual_solicitar_delivery_uber_direct_ecommerce";
import Manual_crear_usuarios_clau_admin from "./components/Help_center_categories/InvuManuales/Clau/Manual_crear_usuarios_clau_admin";
import Manual_configuracion_kiosko_app from "./components/Help_center_categories/InvuManuales/Clau/kiosko/Manual_configuracion_kiosko_app";
import Manual_interfaz_kiosko from "./components/Help_center_categories/InvuManuales/Clau/kiosko/Manual_interfaz_kiosko";
import Manual_posibles_modificaciones_portal_clau from "./components/Help_center_categories/InvuManuales/Clau/portales/Manual_posibles_modificaciones_portal_clau";
import Manual_crear_plantilla_rapida_email from "./components/Help_center_categories/InvuManuales/Clau/portales/Manual_crear_plantilla_rapida_email";
import Manual_crear_plantilla_editor_email from "./components/Help_center_categories/InvuManuales/Clau/portales/Manual_crear_plantilla_editor_email";
import Manual_ver_estadisticas_campanas_email from "./components/Help_center_categories/InvuManuales/Clau/portales/Manual_ver_estadisticas_campanas_email";
import Manual_enviar_emails_dashboard_clau from "./components/Help_center_categories/InvuManuales/Clau/portales/Manual_enviar_emails_dashboard_clau";
import Manual_filtrar_clientes_grupo_id from "./components/Help_center_categories/InvuManuales/Clau/portales/Manual_filtrar_clientes_grupo_id";
import Manual_enviar_notificacion_apps_dashboard_clau from "./components/Help_center_categories/InvuManuales/Clau/portales/Manual_enviar_notificacion_apps_dashboard_clau";
import Manual_invitar_usuarios_passwallet_clau from "./components/Help_center_categories/InvuManuales/Clau/portales/Manual_invitar_usuarios_passwallet_clau";
import Manual_asignar_membresia_usuario_clau from "./components/Help_center_categories/InvuManuales/Clau/portales/Manual_asignar_membresia_usuario_clau";
import Manual_eliminar_clientes_dashboard_clau from "./components/Help_center_categories/InvuManuales/Clau/portales/Manual_eliminar_clientes_dashboard_clau";
import Manual_acciones_masivas_clientes from "./components/Help_center_categories/InvuManuales/Clau/clientes/acciones_masivas/Manual_acciones_masivas_clientes";
import Manual_acciones_individuales_clientes from "./components/Help_center_categories/InvuManuales/Clau/clientes/acciones_masivas/Manual_acciones_individuales_clientes";
import Manual_filtrar_usuarios_regular from "./components/Help_center_categories/InvuManuales/Clau/clientes/acciones_masivas/Manual_filtrar_usuarios_regular";
import Manual_filtrar_usuarios_grupo from "./components/Help_center_categories/InvuManuales/Clau/clientes/acciones_masivas/Manual_filtrar_usuarios_grupo";
import Manual_filtrar_clientes_predefinido from "./components/Help_center_categories/InvuManuales/Clau/clientes/acciones_masivas/Manual_filtrar_clientes_predefinido";
import Manual_etiquetar_eliminar_etiquetas_clientes from "./components/Help_center_categories/InvuManuales/Clau/clientes/acciones_masivas/Manual_etiquetar_eliminar_etiquetas_clientes";
import Manual_subir_clientes_masivamente from "./components/Help_center_categories/InvuManuales/Clau/clientes/subir_descargar/Manual_subir_clientes_masivamente";
import Manual_descargar_clientes_masivamente from "./components/Help_center_categories/InvuManuales/Clau/clientes/subir_descargar/Manual_descargar_clientes_masivamente";
import Manual_editar_lealtad_store_card from "./components/Help_center_categories/InvuManuales/Clau/clientes/subir_descargar/Manual_editar_lealtad_store_card";
import Manual_editar_gift_card from "./components/Help_center_categories/InvuManuales/Clau/clientes/subir_descargar/Manual_editar_gift_card";
import Manual_editar_sucursales_clau from "./components/Help_center_categories/InvuManuales/Clau/clientes/subir_descargar/Manual_editar_sucursales_clau";
import Manual_configurar_niveles_lealtad from "./components/Help_center_categories/InvuManuales/Clau/clientes/subir_descargar/Manual_configurar_niveles_lealtad";
import Manual_acumulacion_canje_expiracion_puntos from "./components/Help_center_categories/InvuManuales/Clau/clientes/subir_descargar/Manual_acumulacion_canje_expiracion_puntos";
import Manual_configuracion_pedidos_programados from "./components/Help_center_categories/InvuManuales/Clau/ecommerce/Manual_configuracion_pedidos_programados";
import Manual_opciones_ecommerce_1 from "./components/Help_center_categories/InvuManuales/Clau/ecommerce/Manual_opciones_ecommerce_1";
import Manual_borrar_productos_ecommerce from "./components/Help_center_categories/InvuManuales/Clau/ecommerce/Manual_borrar_productos_ecommerce";
import Manual_cargar_imagenes_ecommerce from "./components/Help_center_categories/InvuManuales/Clau/ecommerce/Manual_cargar_imagenes_ecommerce";
import Manual_forma_envio_geofence from "./components/Help_center_categories/InvuManuales/Clau/ecommerce/Manual_forma_envio_geofence";
import Manual_metodo_pago_yappy from "./components/Help_center_categories/InvuManuales/Clau/ecommerce/Manual_metodo_pago_yappy";
import Manual_metodo_pago_manual_descripcion from "./components/Help_center_categories/InvuManuales/Clau/ecommerce/Manual_metodo_pago_manual_descripcion";
import Manual_forma_envio_radio_operacion from "./components/Help_center_categories/InvuManuales/Clau/ecommerce/Manual_forma_envio_radio_operacion";
import Manual_forma_envio_region from "./components/Help_center_categories/InvuManuales/Clau/ecommerce/Manual_forma_envio_region";
import Manual_forma_pago_manual_clau from "./components/Help_center_categories/InvuManuales/Clau/ecommerce/Manual_forma_pago_manual_clau";
import Manual_subir_terminos_condiciones from "./components/Help_center_categories/InvuManuales/Clau/ecommerce/Manual_subir_terminos_condiciones";
import Manual_configurar_horarios_pedidos from "./components/Help_center_categories/InvuManuales/Clau/ecommerce/Manual_configurar_horarios_pedidos";
import Manual_configuracion_envio_pickup from "./components/Help_center_categories/InvuManuales/Clau/ecommerce/Manual_configuracion_envio_pickup";
import Manual_setup_stripe_usa_mex from "./components/Help_center_categories/InvuManuales/Clau/ecommerce/Manual_setup_stripe_usa_mex";
import Manual_agregar_link_encuesta_email from "./components/Help_center_categories/InvuManuales/Clau/portales/Manual_agregar_link_encuesta_email";
import Article_que_tan_rentable_es_tu_restaurante_descubre_los_numeros_que_realmente_importan from "./components/Articles/Article_que_tan_rentable_es_tu_restaurante_descubre_los_numeros_que_realmente_importan";
import Manual_importar_cambios_invu_multisucursal from "./components/Help_center_categories/InvuManuales/Clau/configuraciones/Manual_importar_cambios_invu_multisucursal";
import Manual_importar_cambios_invu from "./components/Help_center_categories/InvuManuales/Clau/configuraciones/Manual_importar_cambios_invu";
import Manual_limitar_categorias_horario from "./components/Help_center_categories/InvuManuales/Clau/diseño_grafico/Manual_limitar_categorias_horario";
import Manual_editar_colores_ecommerce from "./components/Help_center_categories/InvuManuales/Clau/diseño_grafico/Manual_editar_colores_ecommerce";
import Manual_cambiar_logos_ecommerce from "./components/Help_center_categories/InvuManuales/Clau/diseño_grafico/Manual_cambiar_logos_ecommerce";
import Manual_cambiar_orden_categorias from "./components/Help_center_categories/InvuManuales/Clau/diseño_grafico/Manual_cambiar_orden_categorias";
import Manual_personalizar_banner_principal from "./components/Help_center_categories/InvuManuales/Clau/diseño_grafico/Manual_personalizar_banner_principal";
import Manual_crear_encuestas from "./components/Help_center_categories/InvuManuales/Clau/encuestas/Manual_crear_encuestas";
import Manual_descargar_respuestas_encuestas from "./components/Help_center_categories/InvuManuales/Clau/encuestas/Manual_descargar_respuestas_encuestas";
import Manual_giftcard_mensuales from "./components/Help_center_categories/InvuManuales/Clau/giftcards/Manual_giftcard_mensuales";
import Manual_redimir_giftcards_invu_pos from "./components/Help_center_categories/InvuManuales/Clau/giftcards/Manual_redimir_giftcards_invu_pos";
import Manual_venta_giftcards_automatica from "./components/Help_center_categories/InvuManuales/Clau/giftcards/Manual_venta_giftcards_automatica";
import Manual_redimir_giftcards_ecommerce from "./components/Help_center_categories/InvuManuales/Clau/giftcards/Manual_redimir_giftcards_ecommerce";
import Manual_subir_giftcards_masivo from "./components/Help_center_categories/InvuManuales/Clau/giftcards/Manual_subir_giftcards_masivo";
import Manual_subir_giftcards_individual from "./components/Help_center_categories/InvuManuales/Clau/giftcards/Manual_subir_giftcards_individual";
import Manual_desactivar_productos_clau from "./components/Help_center_categories/InvuManuales/Clau/productos/Manual_desactivar_productos_clau";
import Manual_crear_producto_dashboard_clau from "./components/Help_center_categories/InvuManuales/Clau/productos/Manual_crear_producto_dashboard_clau";
import Manual_filtrar_productos_dashboard_clau from "./components/Help_center_categories/InvuManuales/Clau/productos/Manual_filtrar_productos_dashboard_clau";
import Manual_herramienta_arreglo_sku from "./components/Help_center_categories/InvuManuales/Clau/promociones/Manual_herramienta_arreglo_sku";
import Manual_beneficio_descuento_categoria from "./components/Help_center_categories/InvuManuales/Clau/promociones/Manual_beneficio_descuento_categoria";
import Manual_beneficio_free_delivery from "./components/Help_center_categories/InvuManuales/Clau/promociones/Manual_beneficio_free_delivery";
import Manual_reportes_beneficios from "./components/Help_center_categories/InvuManuales/Clau/promociones/Manual_reportes_beneficios";
import Manual_promo_combos from "./components/Help_center_categories/InvuManuales/Clau/promociones/Manual_promo_combos";
import Manual_beneficio_2x1 from "./components/Help_center_categories/InvuManuales/Clau/promociones/Manual_beneficio_2x1";
import Manual_beneficios_etiquetas from "./components/Help_center_categories/InvuManuales/Clau/promociones/Manual_beneficios_etiquetas";
import Manual_canjear_beneficios_ecommerce from "./components/Help_center_categories/InvuManuales/Clau/promociones_canjes/Manual_canjear_beneficios_ecommerce";
import Manual_canjear_regalos_cupones_ecommerce from "./components/Help_center_categories/InvuManuales/Clau/promociones_canjes/Manual_canjear_regalos_cupones_ecommerce";
import Manual_canjear_codigos_promocionales_ecommerce from "./components/Help_center_categories/InvuManuales/Clau/promociones_canjes/Manual_canjear_codigos_promocionales_ecommerce";
import Manual_regalo_punch_cards from "./components/Help_center_categories/InvuManuales/Clau/promociones_regalos/Manual_regalo_punch_cards";
import Manual_estadisticas_canje_regalos from "./components/Help_center_categories/InvuManuales/Clau/promociones_regalos/Manual_estadisticas_canje_regalos";
import Manual_regalo_tienda_puntos from "./components/Help_center_categories/InvuManuales/Clau/promociones_regalos/Manual_regalo_tienda_puntos";
import Manual_codigos_promocionales from "./components/Help_center_categories/InvuManuales/Clau/promociones_regalos/Manual_codigos_promocionales";
import Manual_regalo_bienvenida from "./components/Help_center_categories/InvuManuales/Clau/promociones_regalos/Manual_regalo_bienvenida";
import Manual_regalo_cumpleanos from "./components/Help_center_categories/InvuManuales/Clau/promociones_regalos/Manual_regalo_cumpleanos";
import Manual_reporte_inventario from "./components/Help_center_categories/InvuManuales/Clau/dashboard_reportes/Manual_reporte_inventario";
import Manual_reportes_giftcards from "./components/Help_center_categories/InvuManuales/Clau/dashboard_reportes/Manual_reportes_giftcards";
import Manual_reportes_personalizados from "./components/Help_center_categories/InvuManuales/Clau/dashboard_reportes/Manual_reportes_personalizados";
import Manual_reportes_contables_ecommerce from "./components/Help_center_categories/InvuManuales/Clau/dashboard_reportes/Manual_reportes_contables_ecommerce";
import Manual_reportes_info_compra from "./components/Help_center_categories/InvuManuales/Clau/dashboard_reportes/Manual_reportes_info_compra";
import Manual_reportes_info_lealtad from "./components/Help_center_categories/InvuManuales/Clau/dashboard_reportes/Manual_reportes_info_lealtad";
import Manual_reportes_info_productos from "./components/Help_center_categories/InvuManuales/Clau/dashboard_reportes/Manual_reportes_info_productos";
import Manual_reporte_ventas_cliente from "./components/Help_center_categories/InvuManuales/Clau/dashboard_reportes/Manual_reporte_ventas_cliente";
import Manual_config_usuario_administrativo from "./components/Help_center_categories/InvuManuales/InvuClau/invu_admin_config/Manual_config_usuario_administrativo";
import Manual_config_roles_admin from "./components/Help_center_categories/InvuManuales/InvuClau/invu_admin_config/Manual_config_roles_admin";
import Manual_config_roles_ipad from "./components/Help_center_categories/InvuManuales/InvuClau/invu_admin_config/Manual_config_roles_ipad";
import Manual_config_tipo_orden from "./components/Help_center_categories/InvuManuales/InvuClau/invu_admin_config/Manual_config_tipo_orden";
import Manual_config_tipos_pago from "./components/Help_center_categories/InvuManuales/InvuClau/invu_admin_config/Manual_config_tipos_pago";
import Manual_config_tiempos_comida from "./components/Help_center_categories/InvuManuales/InvuClau/invu_admin_config/Manual_config_tiempos_comida";
import Manual_config_propinas from "./components/Help_center_categories/InvuManuales/InvuClau/invu_admin_config/Manual_config_propinas";
import Manual_config_descuentos from "./components/Help_center_categories/InvuManuales/InvuClau/invu_admin_config/Manual_config_descuentos";
import Manual_config_creacion_moneda from "./components/Help_center_categories/InvuManuales/InvuClau/invu_admin_config/Manual_config_creacion_moneda";
import Manual_config_zonas from "./components/Help_center_categories/InvuManuales/InvuClau/invu_admin_config/Manual_config_zonas";
import Manual_config_terminales from "./components/Help_center_categories/InvuManuales/InvuClau/invu_admin_config/Manual_config_terminales";
import Manual_config_impuestos from "./components/Help_center_categories/InvuManuales/InvuClau/invu_admin_config/Manual_config_impuestos";
import Manual_configuracion_imagenes_equipos_doble_pantalla from "./components/Help_center_categories/InvuManuales/InvuClau/invu_admin_otras_config/Manual_configuracion_imagenes_equipos_doble_pantalla";
import Manual_admin_promociones from "./components/Help_center_categories/InvuManuales/InvuClau/invu_admin_otras_config/Manual_admin_promociones";
import Manual_admin_plano_mesa from "./components/Help_center_categories/InvuManuales/InvuClau/invu_admin_otras_config/Manual_admin_plano_mesa";
import Manual_admin_abono_cuenta_personal_clientes from "./components/Help_center_categories/InvuManuales/InvuClau/invu_admin_otras_config/Manual_admin_abono_cuenta_personal_clientes";
import Manual_requisiciones_solicitar from "./components/Help_center_categories/InvuManuales/InvuClau/admin_proveedores/Manual_requisiciones_solicitar";
import Manual_requisiciones_enviar from "./components/Help_center_categories/InvuManuales/InvuClau/admin_proveedores/Manual_requisiciones_enviar";
import Manual_ordenes_compra_crear from "./components/Help_center_categories/InvuManuales/InvuClau/admin_proveedores/Manual_ordenes_compra_crear";
import Manual_proveedores_creacion_interno from "./components/Help_center_categories/InvuManuales/InvuClau/admin_proveedores/Manual_proveedores_creacion_interno";
import Manual_ordenes_compra_revertir_parcial from "./components/Help_center_categories/InvuManuales/InvuClau/admin_proveedores/Manual_ordenes_compra_revertir_parcial";
import Manual_ordenes_compra_revertir_completa from "./components/Help_center_categories/InvuManuales/InvuClau/admin_proveedores/Manual_ordenes_compra_revertir_completa";
import Manual_activar_config_item_clau from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_invu_clau/Manual_activar_config_item_clau";
import Manual_activar_config_subcategoria_clau from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_invu_clau/Manual_activar_config_subcategoria_clau";
import Manual_activar_config_categoria_clau from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_invu_clau/Manual_activar_config_categoria_clau";
import Manual_facturacion_digifact_panama from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_facturacion_digifact_panama";
import Manual_shogo_conexion_invu from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_shogo_conexion_invu";
import Manual_shogo_conexion_ingles from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_shogo_conexion_ingles";
import Manual_quickbook_espanol from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_quickbook_espanol";
import Manual_quickbook_ingles from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_quickbook_ingles";
import Manual_siigo_credenciales from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_siigo_credenciales";
import Manual_siigo_mapeo_journals from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_siigo_mapeo_journals";
import Manual_nota_credito_digifact from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_nota_credito_digifact";
import Manual_yappy_creacion_grupos from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_yappy_creacion_grupos";
import Manual_yappy_boton_pago from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_yappy_boton_pago";
import Manual_yappy_qr from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_yappy_qr";
import Manual_yappy_credenciales from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_yappy_credenciales";
import Manual_kds_agrupacion_flujo from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_kds_agrupacion_flujo";
import Manual_kds_pantallas from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_kds_pantallas";
import Manual_kds_estaciones from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_kds_estaciones";
import Manual_kds_comandas from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_kds_comandas";
import Manual_kds_general from "./components/Help_center_categories/InvuManuales/InvuClau/integraciones_digifact/Manual_kds_general";
import Contact_form from "./components/Home/Contact_form";
import Manual_cloudbeds_conexion_invu from "./components/Help_center_categories/InvuManuales/Cloudbeds/Manual_cloudbeds_conexion_invu";
import Manual_cloudbeds_cargo_habitacion from "./components/Help_center_categories/InvuManuales/Cloudbeds/Manual_cloudbeds_cargo_habitacion";
import Manual_cloudbeds_revision_cargo from "./components/Help_center_categories/InvuManuales/Cloudbeds/Manual_cloudbeds_revision_cargo";
import Article_el_caos_de_fin_de_ano_en_los_restaurantes_como_mantener_el_control_con_invu_pos from "./components/Articles/Article_el_caos_de_fin_de_ano_en_los_restaurantes_como_mantener_el_control_con_invu_pos";
import Article_el_caos_en_la_cocina_no_es_una_opcion_por_que_un_buen_kds_puede_cambiar_tu_cierre_de_ano from "./components/Articles/Article_el_caos_en_la_cocina_no_es_una_opcion_por_que_un_buen_kds_puede_cambiar_tu_cierre_de_ano";
import NavbarPE from "./pages/landingPE/NavbarPE/NavbarPE";
import LandingPE from "./pages/landingPE/LandingPE";
import FooterPE from "./pages/landingPE/FooterPE/FooterPE";
import Article_como_el_programa_de_lealtad_de_invu_pos_impulsa_tus_ventas_en_navidad from "./components/Articles/Article_como_el_programa_de_lealtad_de_invu_pos_impulsa_tus_ventas_en_navidad";
import Article_convierte_la_epoca_mas_movida_del_ano_en_oportunidad_con_el_programa_de_lealtad_de_invu_pos from "./components/Articles/Article_convierte_la_epoca_mas_movida_del_ano_en_oportunidad_con_el_programa_de_lealtad_de_invu_pos";
import Kiosk_new from "./components/modules/Kiosk_new";
import Kds_new from "./components/modules/Kds_new";
import POS_new from "./components/modules/POS_new";
import Article_regalos_que_generan_ingresos_como_vender_giftcards_digitales_con_Invu_POS_esta_navidad from "./components/Articles/Article_regalos_que_generan_ingresos_como_vender_giftcards_digitales_con_Invu_POS_esta_navidad";
import Home_new from "./components/modules/Home_new";
import Article_cierre_de_ano_ventas_al_maximo_como_un_pos_inteligente_impulsa_tu_temporada_de_diciembre from "./components/Articles/Article_cierre_de_ano_ventas_al_maximo_como_un_pos_inteligente_impulsa_tu_temporada_de_diciembre";
import Article_como_preparar_tu_delivery_para_la_temporada_mas_movida_del_ano from "./components/Articles/Article_como_preparar_tu_delivery_para_la_temporada_mas_movida_del_ano";
import Article_control_de_mesas_y_kds_cuando_diciembre_pone_a_prueba_tu_restaurante from "./components/Articles/Article_control_de_mesas_y_kds_cuando_diciembre_pone_a_prueba_tu_restaurante";
import Article_cuentas_separadas_mesas_felices_el_secreto_para_sobrevivir_a_la_temporada_navidena from "./components/Articles/Article_cuentas_separadas_mesas_felices_el_secreto_para_sobrevivir_a_la_temporada_navidena";
import Article_enero_el_mes_perfecto_para_ordenar_tu_negocio_y_vender_mejor_con_un_pos_moderno from "./components/Articles/Article_enero_el_mes_perfecto_para_ordenar_tu_negocio_y_vender_mejor_con_un_pos_moderno";
import Loyalty_new from "./components/modules/Loyaty_new";
import Article_tendencias_tecnologicas_restaurantes_comercios_latinoamerica_2026 from "./components/Articles/Article_tendencias_tecnologicas_restaurantes_comercios_latinoamerica_2026";
import Article_el_futuro_de_los_restaurantes_y_comercios_en_republica_dominicana from "./components/Articles/Article_el_futuro_de_los_restaurantes_y_comercios_en_republica_dominicana";
import Home_new_mx from "./components/modules/Home_new_mx";
import BlogPE from "./components/Blog/BlogPE";
import Article_el_futuro_del_comercio_en_peru_tecnologia_que_impulsa_restaurantes_y_retail from "./components/Articles/Article_el_futuro_del_comercio_en_peru_tecnologia_que_impulsa_restaurantes_y_retail";
import Home_new_rd from "./components/modules/Home_new_rd";
import Article_invupos_mas_ubereats from "./components/Articles/Article_invupos_mas_ubereats";
import Article_las_integraciones_que_todo_restaurante_en_colombia_necesita_en_su_sistema_pos_para_ser_realmente_rentable from "./components/Articles/Article_las_integraciones_que_todo_restaurante_en_colombia_necesita_en_su_sistema_pos_para_ser_realmente_rentable";
import Article_programa_de_lealtad_para_cadenas_en_mexico_como_escalar_la_fidelizacion_en_multiples_sucursales_con_el_mejor_sistema_pos from "./components/Articles/Article_programa_de_lealtad_para_cadenas_en_mexico_como_escalar_la_fidelizacion_en_multiples_sucursales_con_el_mejor_sistema_pos";
import Article_cual_es_el_mejor_sistema_pos_en_peru_para_restaurantes_en_2026 from "./components/Articles/Article_cual_es_el_mejor_sistema_pos_en_peru_para_restaurantes_en_2026";
import Article_facturacion_electronica_en_costa_rica_por_que_necesitas_un_sistema_pos_actualizado_en_2026 from "./components/Articles/Article_facturacion_electronica_en_costa_rica_por_que_necesitas_un_sistema_pos_actualizado_en_2026";
import Article_expo_horeca_2026 from "./components/Articles/Article_expo_horeca_2026";
import Article_como_reducir_perdidas_y_aumentar_ganancias_en_tu_restaurante_en_santo_domingo_con_un_sistema_pos from "./components/Articles/Article_como_reducir_perdidas_y_aumentar_ganancias_en_tu_restaurante_en_santo_domingo_con_un_sistema_pos";
import Article_como_aumentar_frecuencia_clientes_restaurante_sin_invertir_publicidad_punch_card_digital from "./components/Articles/Article_como_aumentar_frecuencia_clientes_restaurante_sin_invertir_publicidad_punch_card_digital";
import Article_como_aumentar_tus_ventas_en_republica_dominicana_con_un_sistema_pos_inteligente_en_2026 from "./components/Articles/Article_como_aumentar_tus_ventas_en_republica_dominicana_con_un_sistema_pos_inteligente_en_2026";
import Article_MasVentasMenosCaosSistemaPOSRentabilidadRestaurantePeru from "./components/Articles/Article_MasVentasMenosCaosSistemaPOSRentabilidadRestaurantePeru";
import Article_como_aumentar_ventas_mexico_sistema_pos_inteligente from "./components/Articles/Article_como_aumentar_ventas_mexico_sistema_pos_inteligente";
import Article_tu_restaurante_perdiendo_dinero_errores_sistema_pos from "./components/Articles/Article_tu_restaurante_perdiendo_dinero_errores_sistema_pos";
import Article_facturacion_electronica_colombia_sistema_pos_2026 from "./components/Articles/Article_facturacion_electronica_colombia_sistema_pos_2026";
import Article_domicilios_sin_caos_panama_gestion_pedidos_restaurante from "./components/Articles/Article_domicilios_sin_caos_panama_gestion_pedidos_restaurante";
import Article_por_que_tu_restaurante_en_peru_pierde_dinero_en_inventario_y_como_solucionarlo_con_un_sistema_pos from "./components/Articles/Article_por_que_tu_restaurante_en_peru_pierde_dinero_en_inventario_y_como_solucionarlo_con_un_sistema_pos";
import Home_new_cl from "./components/modules/Home_new_cl";
import Article_como_integrar_delivery_cocina_y_caja_en_un_solo_sistema_pos_en_republica_dominicana from "./components/Articles/Article_como_integrar_delivery_cocina_y_caja_en_un_solo_sistema_pos_en_republica_dominicana";
import Article_como_un_sistema_pos_puede_transformar_una_cafeteria_en_colombia_beneficios_de_implementar_invu_pos from "./components/Articles/Article_como_un_sistema_pos_puede_transformar_una_cafeteria_en_colombia_beneficios_de_implementar_invu_pos";
import Article_cinco_errores_que_hacen_perder_dinero_a_un_restaurante_en_peru_y_como_evitarlos from "./components/Articles/Article_cinco_errores_que_hacen_perder_dinero_a_un_restaurante_en_peru_y_como_evitarlos";
import Article_el_secreto_de_los_restaurantes_que_mas_crecen_en_colombia_fidelizar_clientes from "./components/Articles/Article_el_secreto_de_los_restaurantes_que_mas_crecen_en_colombia_fidelizar_clientes";
import Article_facturacion_electronica_en_republica_dominicana_como_preparar_tu_negocio_para_una_gestion_mas_eficiente from "./components/Articles/Article_facturacion_electronica_en_republica_dominicana_como_preparar_tu_negocio_para_una_gestion_mas_eficiente";
import Article_como_reducir_las_perdidas_por_inventario_en_un_restaurante_en_el_salvador from "./components/Articles/Article_como_reducir_las_perdidas_por_inventario_en_un_restaurante_en_el_salvador";
import Article_los_beneficios_de_un_sistema_kds_para_restaurantes_con_alto_volumen_de_pedidos from "./components/Articles/Article_los_beneficios_de_un_sistema_kds_para_restaurantes_con_alto_volumen_de_pedidos";
import Article_5_errores_que_cometen_las_tiendas_retail_en_peru_al_administrar_su_inventario_y_como_un_software_pos_puede_evitarlos from "./components/Articles/Article_5_errores_que_cometen_las_tiendas_retail_en_peru_al_administrar_su_inventario_y_como_un_software_pos_puede_evitarlos";
import Article_como_aumentar_el_ticket_promedio_en_una_tienda_sin_subir_los_precios from "./components/Articles/Article_como_aumentar_el_ticket_promedio_en_una_tienda_sin_subir_los_precios";
import Article_las_tendencias_que_estan_transformando_las_cafeterias_en_panama_en_2026_tecnologia_experiencia_y_eficiencia from "./components/Articles/Article_las_tendencias_que_estan_transformando_las_cafeterias_en_panama_en_2026_tecnologia_experiencia_y_eficiencia";
import Article_por_que_cada_vez_mas_restaurantes_en_mexico_estan_cambiando_a_un_sistema_pos_en_la_nube from "./components/Articles/Article_por_que_cada_vez_mas_restaurantes_en_mexico_estan_cambiando_a_un_sistema_pos_en_la_nube";
import Article_como_controlar_el_inventario_de_un_restaurante_y_reducir_las_mermas_en_peru from "./components/Articles/Article_como_controlar_el_inventario_de_un_restaurante_y_reducir_las_mermas_en_peru";
import Home_new_vn from "./components/modules/Home_new_vn";
import Home_new_sv from "./components/modules/Home_new_sv";
import Home_new_gt from "./components/modules/Home_new_gt";
import Home_new_cr from "./components/modules/Home_new_cr";
import Home_new_usa from "./components/modules/Home_new_usa";
import Home_new_tt from "./components/modules/Home_new_tt";
import Home_new_pe from "./components/modules/Home_new_pe";
import Article_cuanto_le_cuesta_a_un_restaurante_colombiano_no_tener_control_de_su_inventario from "./components/Articles/Article_cuanto_le_cuesta_a_un_restaurante_colombiano_no_tener_control_de_su_inventario";
import Article_5_senales_de_que_tu_negocio_en_costa_rica_necesita_un_sistema_pos from "./components/Articles/Article_5_senales_de_que_tu_negocio_en_costa_rica_necesita_un_sistema_pos";
import Article_del_efectivo_a_yappy_como_los_comercios_en_panama_pueden_simplificar_sus_pagos from "./components/Articles/Article_del_efectivo_a_yappy_como_los_comercios_en_panama_pueden_simplificar_sus_pagos";
import Article_como_gestionar_el_inventario_de_tu_negocio_en_venezuela_y_evitar_perdidas_de_ventas from "./components/Articles/Article_como_gestionar_el_inventario_de_tu_negocio_en_venezuela_y_evitar_perdidas_de_ventas";
import Article_7_estrategias_de_fidelizacion_que_pueden_aumentar_las_visitas_recurrentes_a_tu_negocio from "./components/Articles/Article_7_estrategias_de_fidelizacion_que_pueden_aumentar_las_visitas_recurrentes_a_tu_negocio";
import Article_como_tener_el_control_de_tu_restaurante_aunque_no_estes_en_el_local from "./components/Articles/Article_como_tener_el_control_de_tu_restaurante_aunque_no_ estes_en_el_local";
import Article_como_aumentar_la_rentabilidad_de_una_cafeteria_en_panama_sin_vender_mas_cafe from "./components/Articles/Article_como_aumentar_la_rentabilidad_de_una_cafeteria_en_panama_sin_vender_mas_cafe";
import WhatsAppButton from "./components/Home/WhatsAppButton";
import Article_factura_electronica_para_restaurantes_en_colombia_guia_paso_a_paso from "./components/Articles/Article_factura_electronica_para_restaurantes_en_colombia_guia_paso_a_paso";
import Article_sistema_pos_en_republica_dominicana_por_que_tu_negocio_necesita_una_plataforma_todo_integrado from "./components/Articles/Article_sistema_pos_en_republica_dominicana_por_que_tu_negocio_necesita_una_plataforma_todo_integrado";


// Define el componente SelectorPais
const SelectorPais = ({ value, onChange }) => {
  return (
    <FormControl size="small">
      <Select
        labelId="country-select-label"
        id="country-select"
        sx={{
          width: 100,
          height: 35,
          background: '#FDFDFD',
          border: '#FDFDFD',
          fontSize: '0.920rem',
          borderRadius: 10,
        }}
        value={value}
        onChange={onChange}
        style={{ width: '160px' }}
      >
        {/* Panamá siempre primero */}
        <MenuItem value="panama">
          <span className="fi fi-pa"></span> &nbsp; <span>Panamá</span>
        </MenuItem>

        {/* Resto en orden alfabético */}
        <MenuItem value="colombia">
          <span className="fi fi-co"></span> &nbsp; <span>Colombia</span>
        </MenuItem>
        <MenuItem value="costarica">
          <span className="fi fi-cr"></span> &nbsp; <span>Costa Rica</span>
        </MenuItem>
        <MenuItem value="elsalvador">
          <span className="fi fi-sv"></span> &nbsp; <span>El Salvador</span>
        </MenuItem>
        <MenuItem value="guatemala">
          <span className="fi fi-gt"></span> &nbsp; <span>Guatemala</span>
        </MenuItem>
        <MenuItem value="mexico">
          <span className="fi fi-mx"></span> &nbsp; <span>México</span>
        </MenuItem>
        <MenuItem value="peru">
          <span className="fi fi-pe"></span> &nbsp; <span>Perú</span>
        </MenuItem>
        <MenuItem value="republicadominicana">
          <span className="fi fi-do"></span> &nbsp; <span>República Dominicana</span>
        </MenuItem>
        <MenuItem value="trinidadytobago">
          <span className="fi fi-tt"></span> &nbsp; <span>Trinidad y Tobago</span>
        </MenuItem>
        <MenuItem value="unitedstates">
          <span className="fi fi-us"></span> &nbsp; <span>Estados Unidos</span>
        </MenuItem>
        <MenuItem value="venezuela">
          <span className="fi fi-ve"></span> &nbsp; <span>Venezuela</span>
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export { SelectorPais };

const tagManagerArgs = {
  gtmId: "GTM-PKFVV8RW",
};

TagManager.initialize(tagManagerArgs);



const baseRouteUrl = "/:locale(es|en|Panama|Mexico|Venezuela|Elsalvador|Costarica|Colombia|Guatemala|Republicadominicana|Unitedstates|Trinidadytobago|Peru)?";
export const baseUrl = i18n.language === "en" ? "" : "/" + i18n.language;

function App() {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  console.log(lang);


  const history = useHistory();
  const location = useLocation();

  const [geoInfo, setGeoInfo] = useState({
    ip: '',
    countryName: '',
    countryCode: '',
    city: '',
    timezone: ''
  });
  
  const [loading, setLoading] = useState(true);
  const [country, setCountry] = useState(''); 
  const [selectedCountry, setSelectedCountry] = useState('');
  
  const countries = ['Panama', 'Mexico', 'Venezuela', 'Elsalvador', 'Costarica', 'Colombia', 'Guatemala', 'Republicadominicana', 'Unitedstates', 'Trinidadytobago', 'Peru'];

  useEffect(() => {
    if (country) {
      localStorage.setItem("selectedCountry", country);
    }
  }, [country]);


  const countryNameMappings = {
    'Costa Rica': 'Costarica',
    'El Salvador': 'Elsalvador',
    'México': 'mexico',
    'Panamá': 'panama',
    'Dominican Republic': 'Republicadominicana',
    'United States': 'Unitedstates',
    'Trinidad and Tobago': 'Trinidadytobago'
  };
  
  const adjustCountryName = (name) => {
    const adjustedName = countryNameMappings[name];
    return adjustedName ? adjustedName : name;
  };

// LA QUE SE ESTA UTILIZANDO ACTUALMENTE
  const getGeoInfo = (country) => {
    axios
      .get('https://get.geojs.io/v1/ip/geo.json')
      .then((response) => {
        const data = response.data;
  
        if (!data.country_code || !data.country || !data.ip) {
          setCountry('panama');
          return;
        }
  
        const countryName = adjustCountryName(data.country);
  
        setGeoInfo({
          ip: data.ip,
          countryName: data.country,
          countryCode: data.country_code,
          city: data.city,
          timezone: data.timezone,  
        });
  
        if (!country) {
          if (data.country_code === 'US' || data.country_code === 'TT') {
            i18n.changeLanguage('en');
          } else {
            i18n.changeLanguage('es');
          }
        }
  
        setCountry(country != null ? country : countryName);
      })
      .catch((error) => {
        console.error('Error obteniendo geolocalización:', error);
        setCountry('panama');
      })
      .finally(() => {
        setLoading(false);
      });
  };
  

  // const getGeoInfo = (country) => {
  //   axios
  //     .get('https://ipwho.is/')
  //     .then((response) => {
  //       const data = response.data;
  //       if (!data.success) {
  //          setCountry('panama');
  //       }else{
  //       const countryName = adjustCountryName(data.country);
  
  //       setGeoInfo({
  //         ip: data.ip,
  //         countryName: data.country,
  //         countryCode: data.country_code,
  //         city: data.city,
  //         timezone: data.timezone?.id || data.timezone,
  //       });
  
  //       if (!country) {
  //         if (data.country_code === 'US' || data.country_code === 'TT') {
  //           i18n.changeLanguage('en');
  //         } else {
  //           i18n.changeLanguage('es');
  //         }
  //       }
  
  //       setCountry(country != null ? country : countryName);
  //     }
  //     })
  //     .catch((error) => {
  //       console.error('Error obteniendo geolocalización:', error);
  //       setCountry('panama');
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };
  

  // const getGeoInfo = (country) => {
  //   axios
  //     .get('https://ip-api.com/json/')
  //     .then((response) => {
  //       const data = response.data;
  //       if (data.status !== 'success') {
  //         setCountry('panama');
  //       } else {
  //         const countryName = adjustCountryName(data.country);
  
  //         setGeoInfo({
  //           ip: data.query,
  //           countryName: data.country,
  //           countryCode: data.countryCode,
  //           city: data.city,
  //           timezone: data.timezone,
  //         });
  
  //         if (!country) {
  //           if (data.countryCode === 'US' || data.countryCode === 'TT') {
  //             i18n.changeLanguage('en');
  //           } else {
  //             i18n.changeLanguage('es');
  //           }
  //         }
  //         setCountry(country != null ? country : countryName);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Error obteniendo geolocalización:', error);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };

  // const getGeoInfo = (country) => {
  //   axios
  //     .get('https://ipapi.co/json/')
  //     .then((response) => {
  //       const data = response.data;
  //       if (data.error) {
  //         setCountry('panama');
  //         return;
  //       }
  
  //       const countryName = adjustCountryName(data.country_name);
  
  //       setGeoInfo({
  //         ip: data.ip,
  //         countryName: data.country_name,
  //         countryCode: data.country_code,
  //         city: data.city,
  //         timezone: data.timezone,
  //       });
  
  //       if (!country) {
  //         if (data.country_code === 'US' || data.country_code === 'TT') {
  //           i18n.changeLanguage('en');
  //         } else {
  //           i18n.changeLanguage('es');
  //         }
  //       }
  
  //       setCountry(country != null ? country : countryName);
  //     })
  //     .catch((error) => {
  //       console.error('Error obteniendo geolocalización:', error);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // };
  
  const compareCountry = (a, b) => a.toLowerCase() === b.toLowerCase();

  useEffect(() => {
    var country = null;
    if (lang.toLowerCase() === 'panama' || lang.toLowerCase() === 'mexico' || lang.toLowerCase() === 'venezuela' || lang.toLowerCase() === 'elsalvador' || lang.toLowerCase() === 'costarica' || lang.toLowerCase() === 'colombia' || lang.toLowerCase() === 'guatemala' || lang.toLowerCase() === 'republicadominicana' || lang.toLowerCase() === 'unitedstates' || lang.toLowerCase() === 'trinidadytobago' || lang.toLowerCase() === 'peru') {
      country = lang;
    }
    getGeoInfo(country);
  }, []);

  const [firstLoad, setFirstLoad] = useState(false);

  useEffect(() => {
    const pathnameParts = location.pathname.split('/');
    const country = pathnameParts[0];
    if (firstLoad) {
      setFirstLoad(false);
      reloadPageWithSelectedCountry(country);
    } else {
      setSelectedCountry(country);
    }
  }, [location, firstLoad]);

  const handleCountryChange = (event) => {
    const selectedCountry = event.target.value;
    setSelectedCountry(selectedCountry);
  
    // ─── Forzar idioma: inglés solo para USA, español para el resto ───
    if (selectedCountry.toLowerCase() === 'unitedstates' || selectedCountry.toLowerCase() === 'trinidadytobago') {
      i18n.changeLanguage('en');
    } else {
      i18n.changeLanguage('es');
    }
    // ─────────────────────────────────────────────────────────────────────
  
    reloadPageWithSelectedCountry(selectedCountry);
  };

  const reloadPageWithSelectedCountry = (country) => {
    window.location.href = `/${country}`;
  };
  

    // ─── NUEVO: fuerza ‘en’ si la ruta es /unitedstates, ‘es’ para el resto ───
    useEffect(() => {
      const [, pathCountry] = location.pathname.split('/');
      if (pathCountry?.toLowerCase() === 'unitedstates' || pathCountry?.toLowerCase() === 'trinidadytobago') {
        i18n.changeLanguage('en');
      } else {
        i18n.changeLanguage('es');
      }
    }, [location.pathname, i18n]);
    // ─────────────────────────────────────────────────────────────────────
  
  if (loading) {
    return (
      <div></div>
    );
  }

  return (
    <>
      <BrowserRouter>
     
        {/* <div class="px-4 py-0 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 flex justify-end mt-3">
          <SelectorPais value={country.toLowerCase()} onChange={handleCountryChange} />
        </div> */}

        {compareCountry(country, 'Mexico') || compareCountry(country, 'mexico') ? <NavbarMX /> :
          compareCountry(country, 'Venezuela') || compareCountry(country, 'venezuela') ? <NavbarVN /> :
          compareCountry(country, 'Elsalvador') || compareCountry(country, 'elsalvador') ? <NavbarSV /> :
          compareCountry(country, 'Costarica') || compareCountry(country, 'costarica') ? <NavbarCR /> :
          compareCountry(country, 'Colombia') || compareCountry(country, 'colombia') ? <NavbarCL /> :
          compareCountry(country, 'Guatemala') || compareCountry(country, 'guatemala') ? <NavbarGT /> :
          compareCountry(country, 'Republicadominicana') || compareCountry(country, 'republicadominicana') ? <NavbarRD /> :
          compareCountry(country, 'Unitedstates') || compareCountry(country, 'unitedstates') ? <NavbarUSA /> :
          compareCountry(country, 'Trinidadytobago') || compareCountry(country, 'trinidadytobago') ? <NavbarTRI /> :
          compareCountry(country, 'Peru') || compareCountry(country, 'peru') ? <NavbarPE /> :

          <Navbar />
        }


        <Switch>

          <Route
            exact
            path={baseRouteUrl + '/'}
            component={
              (compareCountry(country, 'Mexico') || compareCountry(country, 'mexico')) ? (Home_new_mx) :
              (compareCountry(country, 'Venezuela') || compareCountry(country, 'venezuela')) ? (Home_new_vn) :
              (compareCountry(country, 'Elsalvador') || compareCountry(country, 'elsalvador')) ? (Home_new_sv) :
              (compareCountry(country, 'Costarica') || compareCountry(country, 'costarica')) ? (Home_new_cr) :
              (compareCountry(country, 'Colombia') || compareCountry(country, 'colombia')) ? (Home_new_cl) :
              (compareCountry(country, 'Guatemala') || compareCountry(country, 'guatemala')) ? (Home_new_gt) :
              (compareCountry(country, 'Republicadominicana') || compareCountry(country, 'republicadominicana')) ? (Home_new_rd) :
              (compareCountry(country, 'Unitedstates') || compareCountry(country, 'unitedstates')) ? (Home_new_usa) :
              (compareCountry(country, 'Trinidadytobago') || compareCountry(country, 'trinidadytobago')) ? (Home_new_tt) :
              (compareCountry(country, 'Peru') || compareCountry(country, 'peru')) ? (Home_new_pe) :
              // (Home)
              (Home_new)
            }
          />

          {/* <Route exact path={baseRouteUrl + "/modal-new"}>
            <Modal_new/>
          </Route> */}

          {/* Privacy Policies */}

          <Route exact path={baseRouteUrl + "/politicas-de-privacidad"}>
            <Privacy_policies/>
          </Route>

          {/* Cookie Policy Info */}
          <Route exact path={baseRouteUrl + "/politicas-de-cookies"}>
            <CookiePolicy_info/>
          </Route>

          {/* Products modules */}
          <Route exact path={baseRouteUrl + "/productos/punto-de-venta"}>
            {/* <Point_of_sale /> */}
            <POS_new/>
          </Route>
          <Route exact path={baseRouteUrl + "/productos/comercio-electronico"}>
            {/* <Ecommerce /> */}
            <Ecommerce_new/>
          </Route>
          <Route exact path={baseRouteUrl + "/productos/comercio-electronico-nuevo"}>
            <Ecommerce_new/>
          </Route>
          <Route exact path={baseRouteUrl + "/home-nuevo"}>
            <Home_new/>
          </Route>
          <Route exact path={baseRouteUrl + "/productos/kiosko-nuevo"}>
            <Kiosk_new/> 
          </Route>
          <Route exact path={baseRouteUrl + "/productos/kds-nuevo"}>
            <Kds_new/>
          </Route>
          <Route exact path={baseRouteUrl + "/productos/punto-de-venta-nuevo"}>
            <POS_new/>
          </Route>
          <Route exact path={baseRouteUrl + "/productos/lealtad"}>
            <Loyalty />
          </Route>
          <Route exact path={baseRouteUrl + "/productos/programa-de-lealtad"}>
            {/* <Loyalty_program /> */}
            <Loyalty_new/>
          </Route>
          <Route exact path={baseRouteUrl + "/productos/plus"}>
            <Products_Plus />
          </Route>
          <Route exact path={baseRouteUrl + "/productos/kds"}>
            {/* <Product_KDS /> */}
            <Kds_new/>
          </Route>
          <Route exact path={baseRouteUrl + "/productos/quioscos"}>
            {/* <Product_Kiosks /> anterior */}
            <Kiosk_new/>
          </Route>
          <Route exact path={baseRouteUrl + "/productos/marketing"}>
            <Product_Marketing />
          </Route>

          {/* Payments modules */}
          <Route exact path={baseRouteUrl + "/pagos/general"}>
            <Payments />
          </Route>
          <Route exact path={baseRouteUrl + "/pagos/pagos-en-persona"}>
            <Payment_in_person />
          </Route>
          <Route exact path={baseRouteUrl + "/pagos/pagos-en-su-sitio-web"}>
            <Payments_on_website />
          </Route>
          <Route exact path={baseRouteUrl + "/pagos/procesadores"}>
            <Processor_payment />
          </Route>
          <Route exact path={baseRouteUrl + "/pagos/facturacion-electronica"}>
            <Electronic_invoicing />
          </Route>
          <Route exact path={baseRouteUrl + "/pagos/impresoras-fiscales"}>
            <Fiscal_printers />
          </Route>

          {/* Food and beverage modules */}
          <Route exact path={baseRouteUrl + "/ayb/general"}>
            <Food_and_beverage country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/ayb/bares"}>
            <Pubs country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/ayb/restaurantes"}>
            <Restaurants country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/ayb/comida-rapida"}>
            <Fastfood country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/ayb/food-truck"}>
            <Food_truck country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/ayb/cafeterias"}>
            <Coffee_shop country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/ayb/hoteles"}>
            <Hotel country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/ayb/franquicias"}>
            <Franchises country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/ayb/cocinas-fantasmas"}>
            <Cocina_fantasma country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>

          {/* Retail modules */}

          <Route exact path={baseRouteUrl + "/venta-minorista/general"}>
            <Retail_overview country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/venta-minorista/carnicerias"}>
            <Butcheries country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/venta-minorista/minimercardo"}>
            <Minimarkets country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/venta-minorista/fruterias"}>
            <Greengrocers country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/venta-minorista/ropa"}>
            <Clothing country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/venta-minorista/muebleria"}>
            <Furniture country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/venta-minorista/electronicos"}>
            <Electronics country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>

          {/* Professional services modules */}

          <Route exact path={baseRouteUrl + "/tipos-de-negocios/general"}>
            <Business_types_general country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/tipos-de-negocios/barberia"}>
            <Barber country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/tipos-de-negocios/estudios-de-tatuajes"}>
            <Tatto_studios country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route
            exact
            path={
              baseRouteUrl + "/tipos-de-negocios/profesionales-de-la-belleza"
            }
          >
            <Beauty_professionals country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route
            exact
            path={
              baseRouteUrl + "/tipos-de-negocios/spa-de-dia"
            }
          >
            <Dayspa country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route
            exact
            path={baseRouteUrl + "/tipos-de-negocios/salud-gimnasios"}
          >
            <Health_and_fitness country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route
            exact
            path={baseRouteUrl + "/tipos-de-negocios/servicios-profesionales"}
          >
            <Professional_services_module country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>

          {/* Entertainment modules */}

          <Route exact path={baseRouteUrl + "/entretenimiento/general"}>
            <Enterteiment_general country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/entretenimiento/cines"}>
            <Movies country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/entretenimiento/teatros"}>
            <Theater country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/entretenimiento/festivales"}>
            <Festival country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/entretenimiento/estadios"}>
            <Stadiums country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route exact path={baseRouteUrl + "/entretenimiento/bolos"}>
            <Bolos country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>
          <Route
            exact
            path={baseRouteUrl + "/entretenimiento/salones-de-juegos"}
          >
            <Arcades country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>

          {/* Large business module */}
          <Route exact path={baseRouteUrl + "/empresas-grandes/general"}>
            <Large_business country={country} handleCountryChange={handleCountryChange} selectedCountry={selectedCountry} />
          </Route>

          {/* Resources modules */}

          <Route exact path={baseRouteUrl + "/recursos/acerca-de-invu"}>
            <Why_invu />
          </Route>
          <Route exact path={baseRouteUrl + "/recursos/precios"}>
            <Pricing />
          </Route>
          
          <Route 
            exact 
            path={baseRouteUrl + "/recursos/blog"}
            component={
              (compareCountry(country, 'Venezuela') || compareCountry(country, 'venezuela')) ? (BlogVN) :
              (compareCountry(country, 'Mexico') || compareCountry(country, 'mexico')) ? (BlogMX) :
              (compareCountry(country, 'Elsalvador') || compareCountry(country, 'elsalvador')) ? (BlogSV) :
              (compareCountry(country, 'Costarica') || compareCountry(country, 'costarica')) ? (BlogCR) :
              (compareCountry(country, 'Colombia') || compareCountry(country, 'colombia')) ? (BlogCL) :
              (compareCountry(country, 'Guatemala') || compareCountry(country, 'guatemala')) ? (BlogGT) :
              (compareCountry(country, 'Republicadominicana') || compareCountry(country, 'republicadominicana')) ? (BlogRD) :
              (compareCountry(country, 'Peru') || compareCountry(country, 'peru')) ? (BlogPE) :
              (Blog)
            }
          />

          <Route exact path={baseRouteUrl + "/recursos/que-hay-de-nuevo"}>
            <Whats_news />
          </Route>
          <Route exact path={baseRouteUrl + "/recursos/cambiar-a-invu"}>
            <Switch_invu />
          </Route>

          <Route exact path={baseRouteUrl + "/recursos/referidos"}>
            <Referrals />
          </Route>

          <Route exact path={baseRouteUrl + "/recursos/general"}>
            <Resources />
          </Route>

          {/* Partners modules */}

          <Route exact path={baseRouteUrl + "/socios/distribuidores"}>
            <Dealers />
          </Route>
          <Route exact path={baseRouteUrl + "/socios/desarrolladores"}>
            <Developers />
          </Route>
          <Route exact path={baseRouteUrl + "/socios/plataforma-de-delivery"}>
            <Delivery_platform />
          </Route>
          <Route exact path={baseRouteUrl + "/socios/contadores"}>
            <Counters />
          </Route>

          {/* More tools modules */}

          <Route exact path={baseRouteUrl + "/mas-herramientas/integraciones"}>
            <Integrations />
          </Route>
          <Route exact path={baseRouteUrl + "/mas-herramientas/compras"}>
            <Purchase />
          </Route>
          <Route
            exact
            path={baseRouteUrl + "/mas-herramientas/contabilidad-erps"}
          >
            <Accouting_ERPs />
          </Route>
          <Route
            exact
            path={baseRouteUrl + "/mas-herramientas/gestion-de-inventarios"}
          >
            <Inventory_managment />
          </Route>
          <Route exact path={baseRouteUrl + "/mas-herramientas/producciones"}>
            <Productions />
          </Route>

          {/* About us module */}
          <Route exact path={baseRouteUrl + "/por-que-invu"}>
            <About_us />
          </Route>

          {/* Help modules */}

          <Route exact path={baseRouteUrl + "/centro-de-ayuda"}>
            <Help_center_test />
          </Route>

          {/* <Route exact path={baseRouteUrl + "/centro-de-ayuda-test"}>
            <Help_center_test />
          </Route> */}

          {/* new render manuals */}
          <Route exact path={baseRouteUrl + "/manuales-de-centro-de-ayuda"}>
            <ManualsRenderNew />
          </Route>

          <Route exact path={baseRouteUrl + "/panel-administrativo-test"}>
            <PanelAdmin />
          </Route>

          <Route exact path={baseRouteUrl + "/aplicacion-invu-pos"}>
            <Aplicacion_invupos_guias />
          </Route>

          <Route exact path={baseRouteUrl + "/guias-clau"}>
            <Guias_clau />
          </Route>

          <Route exact path={baseRouteUrl + "/guias-facturacion-electronica"}>
            <Guias_facturacion_electronica />
          </Route>

          <Route exact path={baseRouteUrl + "/integraciones-guias"}>
            <Integraciones_guias />
          </Route>
          
          <Route exact path={baseRouteUrl + "/invu-pos-test"}>
            <InvuApp />
          </Route>

          <Route exact path={baseRouteUrl + "/release-notes-test"}>
            <Release_notes />
          </Route>

          {/* Help Center Modules Categories */}

          <Route exact path={baseRouteUrl + "/menu-sus-categorias"}>
            <Menu_su_categorias />
          </Route>

          {/* Invu POS 3 */}

          <Route exact path={baseRouteUrl + "/software-release/invupos3/abril2025-actualizaciones-de-producto"}>
            <Abril2025_actualizaciones_de_producto />
          </Route>

          {/* Admin */}

          <Route exact path={baseRouteUrl + "/software-release/admin/abril2025-actualizaciones-de-admin"}>
            <Abril2025_actualizaciones_de_admin />
          </Route>

          <Route exact path={baseRouteUrl + "/software-release/admin/abril2025-nuevos-reportes-agregados"}>
            <Abril2025_nuevos_reportes_agregados />
          </Route>


          {/* Other modules  */}

          <Route exact path={baseRouteUrl + "/contacto-con-ventas"}>
            <Contact_sales />
          </Route>
          <Route exact path={baseRouteUrl + "/expertos-de-invu"}>
            <Invu_expert />
          </Route>
          <Route exact path={baseRouteUrl + "/programas-de-revendedores"}>
            <Resellers_program />
          </Route>
          <Route exact path={baseRouteUrl + "/detalles-de-equipos"}>
            <Hardware_details />
          </Route>
          <Route exact path={baseRouteUrl + "/servicios-profesionales"}>
            <Professional_services />
          </Route>

          <Route exact path={baseRouteUrl + "/auth/login"}>
            <Login />
          </Route>
          <Route exact path={baseRouteUrl + "/auth/signup"}>
            <SignUp />
          </Route>

          <Route exact path={baseRouteUrl + "/products-overview"}>
            <Products />
          </Route>

          <Route exact path={baseRouteUrl + "/retail-overview"}>
            <Retail />
          </Route>
          <Route exact path={baseRouteUrl + "/payments/risk-manage"}>
            <Payments_risk_manage />
          </Route>
          <Route exact path={baseRouteUrl + "/payments/on-your-computer"}>
            <Payment_on_computer />
          </Route>
          <Route exact path={baseRouteUrl + "/payments/platform"}>
            <Payment_platform />
          </Route>
          <Route exact path={baseRouteUrl + "/transfers"}>
            <Transfers />
          </Route>
          <Route exact path={baseRouteUrl + "/resources/guides"}>
            <Guides />
          </Route>

          {/* <Route exact path={baseRouteUrl + "/demo-prototipo"}>
            <Demo_figma/>
          </Route> */}

          <Route exact path={baseRouteUrl + "/resources/blog/article-one"}>
            <Article_blog />
          </Route>
          <Route exact path={baseRouteUrl + "/resource/blog/article-two"}>
            <Article_blog_one />
          </Route>

          <Route
            exact
            path={baseRouteUrl + "/business-types/home-and-repair-services"}
          >
            <Home_repair_services />
          </Route>
          <Route exact path={baseRouteUrl + "/careers-invu"}>
            <Careers_main />
          </Route>
          <Route exact path={baseRouteUrl + "/careers-invu/details-job"}>
            <Careers_details />
          </Route>

          <Route exact path={baseRouteUrl + "/thanks-for-sending-message"}>
            <Thanks_sending />
          </Route>

          {/* Prueba Thanks Sending and Pipedrive Contact  */}

          <Route exact path={baseRouteUrl + "/test-thanks-for-sending-message-pipedrive"}>
            <Thanks_sending_pipedrive />
          </Route>

          <Route exact path={baseRouteUrl + "/test-contact-form-pipedrive"}>
            <Contact_pipedrive />
          </Route>

          <Route exact path={baseRouteUrl + "/request-demo-confirmed"}>
            <Demo_confirmed/>
          </Route>

          <Route exact path={baseRouteUrl + "/request-demo-confirmed-external"}>
            <Demo_confirmed_external/>
          </Route>

          <Route exact path={baseRouteUrl + "/contact"}>
            <Form_Contact/>
          </Route>

          {/* test */}
          <Route exact path={baseRouteUrl + "/test-component"}>
            <Button_test_component/>
          </Route>

          {/* Zoho test implementation */}
          <Route exact path={baseRouteUrl + "/zoho-contact-one"}>
            <Contact_form_zoho1/>
          </Route>

          <Route exact path={baseRouteUrl + "/zoho-contact-two"}>
            <Contact_form_zoho2/>
          </Route>

          <Route exact path={baseRouteUrl + "/test-thanks-for-sending-message-zoho"}>
            <Thanks_sending_zoho/>
          </Route>

          <Route exact path={baseRouteUrl + "/preguntas-frecuentes"}>
            <FAQ/>
          </Route>

          <Route exact path={baseRouteUrl + "/explora-preguntas-frecuentes"}>
           <FAQ_business_types/>
          </Route>

          <Route exact path={baseRouteUrl + "/gallery-resources"}>
            <Resources_gallery/>
          </Route>

          <Route exact path={baseRouteUrl + "/gallery-resources/hardware"}>
            <Hardware/>
          </Route>

          <Route exact path={baseRouteUrl + "/gallery-resources/logotypes-invu"}>
            <Logos/>
          </Route>

          <Route exact path={baseRouteUrl + "/gallery-resources/vectores-del-sistema"}>
            <Vector_system/>
          </Route>

          <Route exact path={baseRouteUrl + "/gallery-resources/3D"}>
            <Three_dimension/>
          </Route>

          <Route exact path={baseRouteUrl + "/gallery-resources/KDS"}>
            <Kds/>
          </Route>

          <Route exact path={baseRouteUrl + "/casos-de-exito"}>
            <Case_studies/>
          </Route>
          
          <Route exact path={baseRouteUrl + "/horeca"}>
            <Horeca/>
          </Route>

          <Route exact path={baseRouteUrl + "/software-release"}>
            <Software_release/>
          </Route>

          <Route exact path={baseRouteUrl + "/software-release-details"}>
            <Release_notes_page/>
          </Route>

          <Route exact path={baseRouteUrl + "/ferias"}>
            <Ferias/>
          </Route>

          <Route exact path={baseRouteUrl + "/pagosflexibles"}>
            <Pagosflexibles/>
          </Route>

          <Route exact path={baseRouteUrl + "/delivery"}>
            <Delivery/>
          </Route>

          <Route
            exact
            path={baseRouteUrl + "/blog/programas-de-contabilidad-en-la-nube"}
          >
            <Article_accouting />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl +
              "/blog/sistemas-punto-de-venta-para-tiendas-en-panama"
            }
          >
            <Article_pos_shops />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl + "/blog/como-recibir-pagos-en-linea-en-venezuela"
            }
          >
            <Article_receive_payments />
          </Route>

          <Route
            exact
            path={baseRouteUrl + "/blog/firma-electronica-en-venezuela"}
          >
            <Article_electronic_signature />
          </Route>

          <Route
            exact
            path={baseRouteUrl + "/blog/facturacion-electronica-dgi-2022"}
          >
            <Article_DGI />
          </Route>

          <Route
            exact
            path={baseRouteUrl + "/blog/mejor-programa-de-facturacion-online"}
          >
            <Article_online_billing />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl + "/blog/invu-pos-el-mejor-procesador-de-pago-online"
            }
          >
            <Article_invu_processor />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl + "/blog/software-pos-para-restaurantes-en-venezuela"
            }
          >
            <Article_pos_restaurants />
          </Route>

          <Route exact path={baseRouteUrl + "/blog/e-commerce-con-invu-pos"}>
            <Article_ecommerce_invu />
          </Route>

          <Route exact path={baseRouteUrl + "/blog/loyalty-con-invu-pos"}>
            <Article_loyalty_invu />
          </Route>

          <Route exact path={baseRouteUrl + "/test-manual-de-uso"}>
            <Test_manual_de_uso/>
          </Route>

            {/* manuales de uso - Invu Clau  */}
            <Route exact path={baseRouteUrl + "/general/ver-info-del-cliente-en-pedidos-de-clau-anonimo"}>
            <Manual_ver_info_del_cliente_en_pedidos_de_clau_anonimo/>
          </Route>

          {/* Manuales de uso de - CLAU Exclusivo */}
          <Route exact path={baseRouteUrl + "/general/funciones-configuracion-clau-admin"}>
            <Manual_funciones_configuracion_clau_admin/>
          </Route>

          <Route exact path={baseRouteUrl + "/general/funciones-pos-clau-admin"}>
          <Manual_funciones_pos_clau_admin />
        </Route>

        <Route exact path={baseRouteUrl + "/general/funciones-clientes-clau-admin"}>
          <Manual_funciones_clientes_clau_admin />
        </Route>

        <Route exact path={baseRouteUrl + "/general/funciones-productos-clau-admin"}>
          <Manual_funciones_productos_clau_admin />
        </Route>

        <Route exact path={baseRouteUrl + "/general/funciones-ordenes-clau-admin"}>
          <Manual_funciones_ordenes_clau_admin />
        </Route>

        <Route exact path={baseRouteUrl + "/general/crear-usuarios-clau-admin"}>
          <Manual_crear_usuarios_clau_admin />
        </Route>

        <Route exact path={baseRouteUrl + "/general/canje-regalos-clau-invu"}>
          <Manual_canje_regalos_clau_invu />
        </Route>

        <Route exact path={baseRouteUrl + "/general/cambiar-status-clau-invu"}>
          <Manual_cambiar_status_clau_invu />
        </Route>

        <Route exact path={baseRouteUrl + "/general/flujo-orden-clau-invu-pos"}>
          <Manual_flujo_orden_clau_invu/>
        </Route>

        <Route exact path={baseRouteUrl + "/general/canjear-beneficios-clau-invu-pos"}>
          <Manual_canjear_beneficios_clau_invu />
        </Route>

        <Route exact path={baseRouteUrl + "/general/buscar-clientes-registrados-clau-invu"}>
          <Manual_buscar_clientes_registrados_clau_invu />
        </Route>

        <Route exact path={baseRouteUrl + "/general/solicitar-uber-direct-invu-pos"}>
          <Manual_solicitar_uber_direct_invu />
        </Route>

        <Route exact path={baseRouteUrl + "/general/solicitar-delivery-uber-direct-ecommerce"}>
          <Manual_solicitar_delivery_uber_direct_ecommerce />
        </Route>

        {/*  */}

        {/* 🟦 Clau-kiosko */}
<Route exact path={baseRouteUrl + "/general/configuracion-kiosko-app"}>
  <Manual_configuracion_kiosko_app />
</Route>
<Route exact path={baseRouteUrl + "/general/interfaz-del-kiosko"}>
  <Manual_interfaz_kiosko />
</Route>

{/* 🟪 Clau – Portales */}
<Route exact path={baseRouteUrl + "/general/posibles-modificaciones-portal-clau"}>
  <Manual_posibles_modificaciones_portal_clau />
</Route>
<Route exact path={baseRouteUrl + "/general/agregar-link-encuesta-email"}>
  <Manual_agregar_link_encuesta_email />
</Route>
<Route exact path={baseRouteUrl + "/general/crear-plantilla-rapida-email"}>
  <Manual_crear_plantilla_rapida_email />
</Route>
<Route exact path={baseRouteUrl + "/general/crear-plantilla-editor-email"}>
  <Manual_crear_plantilla_editor_email />
</Route>
<Route exact path={baseRouteUrl + "/general/ver-estadisticas-campanas-email"}>
  <Manual_ver_estadisticas_campanas_email />
</Route>
<Route exact path={baseRouteUrl + "/general/enviar-emails-dashboard-clau"}>
  <Manual_enviar_emails_dashboard_clau />
</Route>
<Route exact path={baseRouteUrl + "/general/filtrar-clientes-grupo-id"}>
  <Manual_filtrar_clientes_grupo_id />
</Route>
<Route exact path={baseRouteUrl + "/general/eliminar-clientes-dashboard-clau"}>
  <Manual_eliminar_clientes_dashboard_clau />
</Route>
<Route exact path={baseRouteUrl + "/general/enviar-notificacion-apps-dashboard-clau"}>
  <Manual_enviar_notificacion_apps_dashboard_clau />
</Route>
<Route exact path={baseRouteUrl + "/general/invitar-usuarios-passwallet-clau"}>
  <Manual_invitar_usuarios_passwallet_clau />
</Route>
<Route exact path={baseRouteUrl + "/general/asignar-membresia-usuario-clau"}>
  <Manual_asignar_membresia_usuario_clau />
</Route>
{/* ------- */}

{/* CLAU – CLIENTES – ACCIONES MASIVAS E INDIVIDUALES */}
<Route exact path={baseRouteUrl + "/general/acciones-masivas-clientes"}>
  <Manual_acciones_masivas_clientes />
</Route>

<Route exact path={baseRouteUrl + "/general/acciones-individuales-clientes"}>
  <Manual_acciones_individuales_clientes />
</Route>

<Route exact path={baseRouteUrl + "/general/filtrar-usuarios-regular"}>
  <Manual_filtrar_usuarios_regular />
</Route>

<Route exact path={baseRouteUrl + "/general/filtrar-usuarios-grupo"}>
  <Manual_filtrar_usuarios_grupo />
</Route>

<Route exact path={baseRouteUrl + "/general/filtrar-clientes-predefinido"}>
  <Manual_filtrar_clientes_predefinido />
</Route>

<Route exact path={baseRouteUrl + "/general/etiquetar-eliminar-etiquetas-clientes"}>
  <Manual_etiquetar_eliminar_etiquetas_clientes />
</Route>

{/* CLAU – CLIENTES – SUBIR Y DESCARGAR CLIENTES MASIVO */}
<Route exact path={baseRouteUrl + "/general/subir-clientes-masivamente"}>
  <Manual_subir_clientes_masivamente />
</Route>

<Route exact path={baseRouteUrl + "/general/descargar-clientes-masivamente"}>
  <Manual_descargar_clientes_masivamente />
</Route>

<Route exact path={baseRouteUrl + "/general/editar-lealtad-store-card"}>
  <Manual_editar_lealtad_store_card />
</Route>

<Route exact path={baseRouteUrl + "/general/editar-gift-card"}>
  <Manual_editar_gift_card />
</Route>

<Route exact path={baseRouteUrl + "/general/editar-sucursales-clau"}>
  <Manual_editar_sucursales_clau />
</Route>

<Route exact path={baseRouteUrl + "/general/configurar-niveles-lealtad"}>
  <Manual_configurar_niveles_lealtad />
</Route>

<Route exact path={baseRouteUrl + "/general/acumulacion-canje-expiracion-puntos"}>
  <Manual_acumulacion_canje_expiracion_puntos />
</Route>

{/* 📦 CLAU – CONFIGURACIÓN – ECOMMERCE */}

<Route exact path={baseRouteUrl + "/general/configuracion-pedidos-programados"}>
  <Manual_configuracion_pedidos_programados />
</Route>

<Route exact path={baseRouteUrl + "/general/opciones-ecommerce-1"}>
  <Manual_opciones_ecommerce_1 />
</Route>

<Route exact path={baseRouteUrl + "/general/borrar-productos-ecommerce"}>
  <Manual_borrar_productos_ecommerce />
</Route>

<Route exact path={baseRouteUrl + "/general/cargar-imagenes-ecommerce"}>
  <Manual_cargar_imagenes_ecommerce />
</Route>

<Route exact path={baseRouteUrl + "/general/forma-envio-geofence"}>
  <Manual_forma_envio_geofence />
</Route>

<Route exact path={baseRouteUrl + "/general/metodo-pago-yappy"}>
  <Manual_metodo_pago_yappy />
</Route>

<Route exact path={baseRouteUrl + "/general/metodo-pago-manual-descripcion"}>
  <Manual_metodo_pago_manual_descripcion />
</Route>

<Route exact path={baseRouteUrl + "/general/forma-envio-radio-operacion"}>
  <Manual_forma_envio_radio_operacion />
</Route>

<Route exact path={baseRouteUrl + "/general/forma-envio-region"}>
  <Manual_forma_envio_region />
</Route>

<Route exact path={baseRouteUrl + "/general/forma-pago-manual-clau"}>
  <Manual_forma_pago_manual_clau />
</Route>

<Route exact path={baseRouteUrl + "/general/subir-terminos-condiciones"}>
  <Manual_subir_terminos_condiciones />
</Route>

<Route exact path={baseRouteUrl + "/general/configurar-horarios-pedidos"}>
  <Manual_configurar_horarios_pedidos />
</Route>

<Route exact path={baseRouteUrl + "/general/configuracion-envio-pickup"}>
  <Manual_configuracion_envio_pickup />
</Route>

<Route exact path={baseRouteUrl + "/general/setup-stripe-usa-mex"}>
  <Manual_setup_stripe_usa_mex />
</Route>


{/*  */}

{/* ⚙️ CLAU – CONFIGURACIÓN – PARÁMETROS DE CONFIGURACIÓN GENERALES */}

<Route exact path={baseRouteUrl + "/general/importar-cambios-invu-multisucursal"}>
  <Manual_importar_cambios_invu_multisucursal/>
</Route>

<Route exact path={baseRouteUrl + "/general/importar-cambios-invu"}>
  <Manual_importar_cambios_invu/>
</Route>

{/* 🎨 CLAU – DISEÑO GRÁFICO */}

<Route exact path={baseRouteUrl + "/general/limitar-categorias-horario"}>
  <Manual_limitar_categorias_horario />
</Route>

<Route exact path={baseRouteUrl + "/general/editar-colores-ecommerce"}>
  <Manual_editar_colores_ecommerce/>
</Route>

<Route exact path={baseRouteUrl + "/general/cambiar-logos-ecommerce"}>
  <Manual_cambiar_logos_ecommerce/>
</Route>

<Route exact path={baseRouteUrl + "/general/cambiar-orden-categorias"}>
  <Manual_cambiar_orden_categorias/>
</Route>

<Route exact path={baseRouteUrl + "/general/personalizar-banner-principal"}>
  <Manual_personalizar_banner_principal/>
</Route>

{/* 📝 CLAU – ENCUESTAS */}

<Route exact path={baseRouteUrl + "/general/crear-encuestas"}>
  <Manual_crear_encuestas/>
</Route>

<Route exact path={baseRouteUrl + "/general/descargar-respuestas-encuestas"}>
  <Manual_descargar_respuestas_encuestas/>
</Route>

{/* 🎁 CLAU – GIFTCARDS */}

<Route exact path={baseRouteUrl + "/general/giftcard-mensuales"}>
  <Manual_giftcard_mensuales/>
</Route>

<Route exact path={baseRouteUrl + "/general/redimir-giftcards-ecommerce"}>
  <Manual_redimir_giftcards_ecommerce/>
</Route>

<Route exact path={baseRouteUrl + "/general/venta-giftcards-automatica"}>
  <Manual_venta_giftcards_automatica/>
</Route>

<Route exact path={baseRouteUrl + "/general/redimir-giftcards-ecommerce"}>
  <Manual_redimir_giftcards_ecommerce/>
</Route>

<Route exact path={baseRouteUrl + "/general/subir-giftcards-masivo"}>
  <Manual_subir_giftcards_masivo/>
</Route>

<Route exact path={baseRouteUrl + "/general/subir-giftcards-individual"}>
  <Manual_subir_giftcards_individual />
</Route>

{/* 🛒 CLAU – PRODUCTOS */}

<Route exact path={baseRouteUrl + "/general/desactivar-productos-clau"}>
  <Manual_desactivar_productos_clau/>
</Route>

<Route exact path={baseRouteUrl + "/general/crear-producto-dashboard-clau"}>
  <Manual_crear_producto_dashboard_clau/>
</Route>

<Route exact path={baseRouteUrl + "/general/filtrar-productos-dashboard-clau"}>
  <Manual_filtrar_productos_dashboard_clau/>
</Route>

{/* 🎟️ CLAU – PROMOCIONES */}

<Route exact path={baseRouteUrl + "/general/herramienta-arreglo-sku"}>
  <Manual_herramienta_arreglo_sku/>
</Route>

<Route exact path={baseRouteUrl + "/general/beneficio-descuento-categoria"}>
  <Manual_beneficio_descuento_categoria/>
</Route>

<Route exact path={baseRouteUrl + "/general/beneficio-free-delivery"}>
  <Manual_beneficio_free_delivery/>
</Route>

<Route exact path={baseRouteUrl + "/general/reportes-beneficios"}>
  <Manual_reportes_beneficios/>
</Route>

<Route exact path={baseRouteUrl + "/general/promo-combos"}>
  <Manual_promo_combos/>
</Route>

<Route exact path={baseRouteUrl + "/general/beneficio-2x1"}>
  <Manual_beneficio_2x1/>
</Route>

<Route exact path={baseRouteUrl + "/general/beneficios-etiquetas"}>
  <Manual_beneficios_etiquetas/>
</Route>


{/* 🛍️ CLAU – PROMOCIONES – CANJES */}

<Route exact path={baseRouteUrl + "/general/canjear-beneficios-ecommerce"}>
  <Manual_canjear_beneficios_ecommerce/>
</Route>

<Route exact path={baseRouteUrl + "/general/canjear-regalos-cupones-ecommerce"}>
  <Manual_canjear_regalos_cupones_ecommerce/>
</Route>

<Route exact path={baseRouteUrl + "/general/canjear-codigos-promocionales-ecommerce"}>
  <Manual_canjear_codigos_promocionales_ecommerce/>
</Route>

{/* 🎁 CLAU – PROMOCIONES – REGALOS */}

<Route exact path={baseRouteUrl + "/general/regalo-punch-cards"}>
  <Manual_regalo_punch_cards/>
</Route>

<Route exact path={baseRouteUrl + "/general/estadisticas-canje-regalos"}>
  <Manual_estadisticas_canje_regalos/>
</Route>

<Route exact path={baseRouteUrl + "/general/regalo-tienda-puntos"}>
  <Manual_regalo_tienda_puntos/>
</Route>

<Route exact path={baseRouteUrl + "/general/codigos-promocionales"}>
  <Manual_codigos_promocionales/>
</Route>

<Route exact path={baseRouteUrl + "/general/regalo-bienvenida"}>
  <Manual_regalo_bienvenida/>
</Route>

<Route exact path={baseRouteUrl + "/general/regalo-cumpleanos"}>
  <Manual_regalo_cumpleanos/>
</Route>

{/* 📊 CLAU – DASHBOARD – REPORTES */}

<Route exact path={baseRouteUrl + "/general/reporte-inventario"}>
  <Manual_reporte_inventario/>
</Route>

<Route exact path={baseRouteUrl + "/general/reportes-giftcards"}>
  <Manual_reportes_giftcards/>
</Route>

<Route exact path={baseRouteUrl + "/general/reportes-personalizados"}>
  <Manual_reportes_personalizados/>
</Route>

<Route exact path={baseRouteUrl + "/general/reportes-contables-ecommerce"}>
<Manual_reportes_contables_ecommerce/>
</Route>
  

<Route exact path={baseRouteUrl + "/general/reportes-info-compra"}>
  <Manual_reportes_info_compra/>
</Route>

<Route exact path={baseRouteUrl + "/general/reportes-info-lealtad"}>
  <Manual_reportes_info_lealtad/>
</Route>

<Route exact path={baseRouteUrl + "/general/reportes-info-productos"}>
  <Manual_reportes_info_productos/>
</Route>

<Route exact path={baseRouteUrl + "/general/reporte-ventas-cliente"}>
  <Manual_reporte_ventas_cliente/>
</Route>

{/* INVU POS – ADMIN – CONFIGURACIÓN */}

<Route exact path={baseRouteUrl + "/general/config-usuario-administrativo"}>
  <Manual_config_usuario_administrativo />
</Route>

<Route exact path={baseRouteUrl + "/general/config-roles-administrador"}>
  <Manual_config_roles_admin />
</Route>

<Route exact path={baseRouteUrl + "/general/config-roles-ipad"}>
  <Manual_config_roles_ipad />
</Route>

<Route exact path={baseRouteUrl + "/general/config-tipos-pago"}>
  <Manual_config_tipos_pago />
</Route>

<Route exact path={baseRouteUrl + "/general/config-tiempos-comida"}>
  <Manual_config_tiempos_comida/>
</Route>

<Route exact path={baseRouteUrl + "/general/config-tipo-orden"}>
  <Manual_config_tipo_orden/>
</Route>

<Route exact path={baseRouteUrl + "/general/config-propinas"}>
  <Manual_config_propinas/>
</Route>

<Route exact path={baseRouteUrl + "/general/config-descuentos"}>
  <Manual_config_descuentos/>
</Route>

<Route exact path={baseRouteUrl + "/general/config-impuestos"}>
  <Manual_config_impuestos/>
</Route>

<Route exact path={baseRouteUrl + "/general/config-creacion-moneda"}>
  <Manual_config_creacion_moneda/>
</Route>

<Route exact path={baseRouteUrl + "/general/config-zonas"}>
  <Manual_config_zonas/>
</Route>

<Route exact path={baseRouteUrl + "/general/config-terminales"}>
  <Manual_config_terminales/>
</Route>

{/* INVU POS – ADMIN – OTRAS CONFIGURACIONES */}

<Route exact path={baseRouteUrl + "/general/configuracion-imagenes-equipos-doble-pantalla"}>
  <Manual_configuracion_imagenes_equipos_doble_pantalla />
</Route>

<Route exact path={baseRouteUrl + "/general/admin-promociones"}>
  <Manual_admin_promociones />
</Route>

<Route exact path={baseRouteUrl + "/general/admin-faceid-empleados"}>
  <Manual_admin_faceid_empleados />
</Route>

<Route exact path={baseRouteUrl + "/general/admin-comandas"}>
  <Manual_admin_comandas />
</Route>

<Route exact path={baseRouteUrl + "/general/admin-caja-registradora"}>
  <Manual_admin_caja_registradora />
</Route>

<Route exact path={baseRouteUrl + "/general/admin-plano-mesa"}>
  <Manual_admin_plano_mesa />
</Route>

<Route exact path={baseRouteUrl + "/general/admin-crear-clientes"}>
  <Manual_admin_crear_clientes />
</Route>

<Route exact path={baseRouteUrl + "/general/admin-empleados"}>
  <Manual_admin_empleados />
</Route>

<Route exact path={baseRouteUrl + "/general/admin-abono-cuenta-personal-clientes"}>
  <Manual_admin_abono_cuenta_personal_clientes />
</Route>

{/* ADMIN PROVEEDORES */}

<Route exact path={baseRouteUrl + "/general/requisiciones-solicitar"}>
  <Manual_requisiciones_solicitar/>
</Route>
<Route exact path={baseRouteUrl + "/general/requisiciones-enviar"}>
  <Manual_requisiciones_enviar/>
</Route>
<Route exact path={baseRouteUrl + "/general/ordenes-compra-crear"}>
  <Manual_ordenes_compra_crear/>
</Route>
<Route exact path={baseRouteUrl + "/general/proveedores-creacion-interno"}>
  <Manual_proveedores_creacion_interno/>
</Route>
<Route exact path={baseRouteUrl + "/general/ordenes-compra-revertir-parcial"}>
  <Manual_ordenes_compra_revertir_parcial/>
</Route>
<Route exact path={baseRouteUrl + "/general/ordenes-compra-revertir-completa"}>
  <Manual_ordenes_compra_revertir_completa/>
</Route>
<Route exact path={baseRouteUrl + "/general/ordenes-compra-compra-rapida"}>
  <Manual_ordenes_compra_compra_rapida/>
</Route>

{/* INTEGRACIONES INVU CLAU  */}
<Route exact path={baseRouteUrl + "/general/activar-config-item-clau"}>
  <Manual_activar_config_item_clau/>
</Route>
<Route exact path={baseRouteUrl + "/general/activar-config-subcategoria-clau"}>
  <Manual_activar_config_subcategoria_clau/>
</Route>
<Route exact path={baseRouteUrl + "/general/activar-config-categoria-clau"}>
  <Manual_activar_config_categoria_clau/>
</Route>

{/* INTEGRACIONES DIGIFACT */}

<Route exact path={baseRouteUrl + "/general/nota-credito-digifact"}>
  <Manual_nota_credito_digifact/>
</Route>
<Route exact path={baseRouteUrl + "/general/facturacion-digifact-panama"}>
  <Manual_facturacion_digifact_panama/>
</Route>
<Route exact path={baseRouteUrl + "/general/shogo-conexion-invu"}>
  <Manual_shogo_conexion_invu/>
</Route>
<Route exact path={baseRouteUrl + "/general/shogo-conexion-ingles"}>
  <Manual_shogo_conexion_ingles/>
</Route>
<Route exact path={baseRouteUrl + "/general/quickbook-espanol"}>
  <Manual_quickbook_espanol/>
</Route>
<Route exact path={baseRouteUrl + "/general/quickbook-ingles"}>
  <Manual_quickbook_ingles/>
</Route>
<Route exact path={baseRouteUrl + "/general/siigo-credenciales"}>
  <Manual_siigo_credenciales/>
</Route>
<Route exact path={baseRouteUrl + "/general/siigo-mapeo-journals"}>
  <Manual_siigo_mapeo_journals/>
</Route>

{/* Yappy Híbrido */}
<Route exact path={baseRouteUrl + "/general/yappy-creacion-grupos"}>
  <Manual_yappy_creacion_grupos/>
</Route>
<Route exact path={baseRouteUrl + "/general/yappy-boton-pago"}>
  <Manual_yappy_boton_pago/>
</Route>
<Route exact path={baseRouteUrl + "/general/yappy-qr"}>
  <Manual_yappy_qr/>
</Route>
<Route exact path={baseRouteUrl + "/general/yappy-credenciales"}>
  <Manual_yappy_credenciales/>
</Route>

{/* KDS */}
<Route exact path={baseRouteUrl + "/general/kds-agrupacion-flujo"}>
  <Manual_kds_agrupacion_flujo/>
</Route>
<Route exact path={baseRouteUrl + "/general/kds-pantallas"}>
  <Manual_kds_pantallas/>
</Route>
<Route exact path={baseRouteUrl + "/general/kds-estaciones"}>
  <Manual_kds_estaciones/>
</Route>
<Route exact path={baseRouteUrl + "/general/kds-comandas"}>
  <Manual_kds_comandas/>
</Route>
<Route exact path={baseRouteUrl + "/general/kds-general"}>
  <Manual_kds_general/>
</Route>



          <Route exact path={baseRouteUrl + "/general/proveedores-producto-por-proveedor"}>
            <Manual_proveedores_producto_por_proveedor/>
          </Route>
          <Route exact path={baseRouteUrl + "/general/admin-abono-a-cuenta-personal-clientes"}>
            <Manual_admin_abono_a_cuenta_personal_clientes/>
          </Route>
          <Route exact path={baseRouteUrl + "/general/requisiciones-solicitar-una-requisicion"}>
            <Manual_requisiciones_solicitar_una_requisicion/>
          </Route>
          <Route exact path={baseRouteUrl + "/general/requisiciones-enviar-una-requisicion"}>
            <Manual_requisiciones_enviar_una_requisicion/>
          </Route>
          <Route exact path={baseRouteUrl + "/general/ordenes-de-compra-crear-orden-de-compra"}>
            <Manual_ordenes_de_compra_crear_orden_de_compra/>
          </Route>
          {/*  */}
          <Route exact path={baseRouteUrl + "/general/invukds-configuracion-pantallas"}>
            <Manual_invukds_configuracion_pantallas/>
          </Route>
          <Route exact path={baseRouteUrl + "/general/invukds-configuracion-estaciones"}>
            <Manual_invukds_configuraciones_estaciones/>
          </Route>
          <Route exact path={baseRouteUrl + "/general/invukds-configuracion-agrupacion-y-flujo"}>
            <Manual_invuKDS_configuracion_agrupacion_flujo/>
          </Route>
          <Route exact path={baseRouteUrl + "/general/invukds-comandas"}>
            <Manual_invuKDS_comandas/>
          </Route>
          <Route exact path={baseRouteUrl + "/general/invukds-configuraciones-general"}>
            <Manual_invukds_configuraciones_general/>
          </Route>
          <Route exact path={baseRouteUrl + "/general/invupos-pagos-automaticos"}>
            <Manual_invuPOS_pagos_automaticos/>
          </Route>


          <Route exact path={baseRouteUrl + "/general/menu-promociones"}>
            <Manual_menu_promociones />
          </Route>
          <Route exact path={baseRouteUrl + "/general/orden-de-subcategorias"}>
            <Manual_orden_de_subcategorias />
          </Route>
          <Route exact path={baseRouteUrl + "/general/menu-comisiones"}>
            <Manual_menu_comisiones />
          </Route>
          <Route exact path={baseRouteUrl + "/general/menu-categoria"}>
            <Manual_menu_categoria />
          </Route>
          <Route exact path={baseRouteUrl + "/general/menu-modificadores-opciones"}>
            <Manual_menu_modificadores_opciones />
          </Route>
          <Route exact path={baseRouteUrl + "/general/menu-items"}>
            <Manual_menu_items />
          </Route>
          <Route exact path={baseRouteUrl + "/general/menu-subcategorias"}>
            <Manual_menu_subcategorias />
          </Route>

          {/*  */}

          <Route exact path={baseRouteUrl + "/general/admin-crear-clientes"}>
            <Manual_admin_crear_clientes />
          </Route>

          <Route exact path={baseRouteUrl + "/general/admin-plano-de-mesa"}>
            <Manual_admin_plano_de_mesa />
          </Route>

          <Route exact path={baseRouteUrl + "/general/proveedores-creacion-proveedor-interno"}>
            <Manual_proveedores_creacion_proveedor_interno />
          </Route>

          <Route exact path={baseRouteUrl + "/general/ordenes-compra-revertir-parcialmente"}>
            <Manual_ordenes_compra_revertir_parcialmente />
          </Route>

          <Route exact path={baseRouteUrl + "/general/ordenes-compra-revertir-orden-completa"}>
            <Manual_ordenes_compra_revertir_orden_completa />
          </Route>

          <Route exact path={baseRouteUrl + "/general/admin-roles-ipad"}>
            <Manual_admin_roles_ipad />
          </Route>

          <Route exact path={baseRouteUrl + "/general/admin-descuentos"}>
            <Manual_admin_descuentos />
          </Route>

          <Route exact path={baseRouteUrl + "/general/ordenes-compra-compra-rapida"}>
            <Manual_ordenes_compra_compra_rapida />
          </Route>

          <Route exact path={baseRouteUrl + "/general/orden-opciones-modificadores"}>
            <Manual_orden_opciones_modificadores />
          </Route>

          <Route exact path={baseRouteUrl + "/general/orden-categorias"}>
            <Manual_orden_categorias />
          </Route>

          {/*  */}

          <Route exact path={baseRouteUrl + "/general/orden-menu"}>
            <Manual_orden_menu/>
          </Route>

          <Route exact path={baseRouteUrl + "/general/orden-modificadores"}>
            <Manual_orden_modificadores/>
          </Route>

          <Route exact path={baseRouteUrl + "/general/admin-caja-registradora"}>
            <Manual_admin_caja_registradora/>
          </Route>

          <Route exact path={baseRouteUrl + "/general/menu-modificadores-precios-multiples"}>
            <Manual_menu_modificadores_precios_multiples/>
          </Route>

          <Route exact path={baseRouteUrl + "/general/menu-item-precios-multiples"}>
            <Manual_menu_item_precios_multiples />
          </Route>

          <Route exact path={baseRouteUrl + "/general/admin-tiempos-comida"}>
            <Manual_admin_tiempos_comida />
          </Route>

          <Route exact path={baseRouteUrl + "/general/proveedores-gestionar-proveedores"}>
            <Manual_proveedores_gestionar_proveedores />
          </Route>

          <Route exact path={baseRouteUrl + "/general/inventario-recetas"}>
            <Manual_inventario_recetas />
          </Route>

          <Route exact path={baseRouteUrl + "/general/inventario-mermas"}>
            <Manual_inventario_mermas />
          </Route>

          <Route exact path={baseRouteUrl + "/general/inventario-tipos-mermas"}>
            <Manual_inventario_tipos_mermas />
          </Route>

          {/* 21 al 30 */}
          <Route exact path={baseRouteUrl + "/general/inventario-conteo-inventario"}>
            <Manual_inventario_conteo_inventario />
          </Route>

          <Route exact path={baseRouteUrl + "/general/inventario-receta-opciones-modificadores"}>
            <Manual_inventario_receta_modificadores />
          </Route>

          <Route exact path={baseRouteUrl + "/general/inventario-ajuste-subreceta"}>
            <Manual_inventario_ajuste_subreceta />
          </Route>

          <Route exact path={baseRouteUrl + "/general/inventario-ajuste-inventario"}>
            <Manual_inventario_ajuste_inventario />
          </Route>

          <Route exact path={baseRouteUrl + "/general/inventario-subrecetas"}>
            <Manual_inventario_subrecetas />
          </Route>

          <Route exact path={baseRouteUrl + "/general/inventario-ingredientes"}>
            <Manual_inventario_ingredientes />
          </Route>

          <Route exact path={baseRouteUrl + "/general/inventario-categoria-producto"}>
            <Manual_inventario_categoria_producto />
          </Route>

          <Route exact path={baseRouteUrl + "/general/inventario-categoria-producto-dos"}>
            <Manual_inventario_categoria_producto_dos />
          </Route>

          <Route exact path={baseRouteUrl + "/general/admin-comandas"}>
            <Manual_admin_comandas />
          </Route>

          <Route exact path={baseRouteUrl + "/general/admin-roles-administrador"}>
            <Manual_admin_roles_administrador />
          </Route>

          {/* 31 al 38 */}
          <Route exact path={baseRouteUrl + "/general/admin-tipos-pago"}>
            <Manual_admin_tipos_pago />
          </Route>

          <Route exact path={baseRouteUrl + "/general/admin-propinas"}>
            <Manual_admin_propinas />
          </Route>

          <Route exact path={baseRouteUrl + "/general/admin-tipo-orden"}>
            <Manual_admin_tipo_orden />
          </Route>

          <Route exact path={baseRouteUrl + "/general/admin-impuestos"}>
            <Manual_admin_impuestos />
          </Route>

          <Route exact path={baseRouteUrl + "/general/admin-usuario-administrativo"}>
            <Manual_admin_usuario_administrativo />
          </Route>

          <Route exact path={baseRouteUrl + "/general/admin-empleados"}>
            <Manual_admin_empleados />
          </Route>

          <Route exact path={baseRouteUrl + "/general/admin-faceid-empleados"}>
            <Manual_admin_faceid_empleados />
          </Route>

          <Route exact path={baseRouteUrl + "/general/invupos-reimpresion-ordenes"}>
            <Manual_invupos_reimpresion_ordenes />
          </Route>

          {/*  */}

          <Route exact path={baseRouteUrl + "/general/digifact-descarga-reporte"}>
            <Manual_digifact_descarga_reporte />
          </Route>

          <Route exact path={baseRouteUrl + "/general/cliente-extranjero-el-salvador"}>
            <Manual_cliente_extranjero_sv />
          </Route>

          <Route exact path={baseRouteUrl + "/general/cliente-juridico-el-salvador"}>
            <Manual_cliente_juridico_sv />
          </Route>

          <Route exact path={baseRouteUrl + "/general/cliente-natural-el-salvador"}>
            <Manual_cliente_natural_sv />
          </Route>

          <Route exact path={baseRouteUrl + "/general/cliente-natural-guatemala"}>
            <Manual_cliente_natural_gt />
          </Route>


          {/* Manuales de uso - Yappy */}

          <Route exact path={baseRouteUrl + "/yappy/creacion-de-grupos-y-unidades-de-cobro"}>
            <Manual_creacion_de_grupos_y_unidades_de_cobro/>
          </Route>
          <Route exact path={baseRouteUrl + "/yappy/creacion-de-boton-de-pago-de-yappy"}>
            <Manual_creacion_de_boton_de_pago_yappy/>
          </Route>
          <Route exact path={baseRouteUrl + "/yappy/generacion-de-credenciales"}>
            <Manual_generacion_de_credenciales/>
          </Route>
          <Route exact path={baseRouteUrl + "/yappy/generacion-de-qr"}>
            <Manual_generacion_de_qr/>
          </Route>

          {/* Manuales de uso - Deliverect */}
          <Route exact path={baseRouteUrl + "/deliverect/tipo-de-orden"}>
            <Manual_tipo_de_orden/>
          </Route>
          <Route exact path={baseRouteUrl + "/deliverect/configuracion-de-item"}>
            <Manual_configuracion_de_item/>
          </Route>
          <Route exact path={baseRouteUrl + "/deliverect/creacion-de-tipo-de-pago"}>
            <Manual_creacion_de_tipo_de_pago/>
          </Route>
          <Route exact path={baseRouteUrl + "/deliverect/activacion-de-caja-para-pedidos"}>
            <Manual_activacion_de_caja_para_pedidos/>
          </Route>

          {/* Manuales de uso - Cloudbeds */}
          <Route exact path={baseRouteUrl + "/cloudbeds/tipo-de-pago"}>
            <Manual_tipo_de_pago_cloudbeds/>
          </Route>
          <Route exact path={baseRouteUrl + "/cloudbeds/tipo-de-orden"}>
            <Manual_tipo_de_orden_cloudbeds/>
          </Route>
          <Route exact path={baseRouteUrl + "/cloudbeds/cloudbeds-conexion-invu"}>
            <Manual_cloudbeds_conexion_invu/>
          </Route>
          <Route exact path={baseRouteUrl + "/cloudbeds/cloudbeds-cargo-habitacion"}>
            <Manual_cloudbeds_cargo_habitacion/>
          </Route>
          <Route exact path={baseRouteUrl + "/cloudbeds/cloudbeds-revision-cargo"}>
            <Manual_cloudbeds_revision_cargo/>
          </Route>
          {/* Manuales de uso - Marketman */}
          <Route exact path={baseRouteUrl + "/marketman/conexion-de-cuenta"}>
            <Manual_conexion_de_cuenta/>
          </Route>

          <Route
            exact
            path={
              baseRouteUrl +
              "/blog/como-evitar-perder-materia-prima-en-los-inventarios"
            }
          >
            <Article_lose_matter />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl +
              "/blog/cuatro-funciones-del-sistema-invupos-para-mejorar-control-de-ventas"
            }
          >
            <Article_four_functions />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl +
              "/blog/consejos-para-diseñar-la-pagina-web-de-un-restaurante"
            }
          >
            <Article_tips_design_web />
          </Route>

          <Route
            exact
            path={baseRouteUrl + "/blog/que-es-el-cash-flow-y-como-mejorarlo"}
          >
            <Article_cash_flow />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl + "/blog/ventajas-de-unificar-con-el-sistema-pos"
            }
          >
            <Articles_sales_offline_online />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl +
              "/blog/seis-funciones-indispensables-en-el-punto-de-venta-para-controlar-las-sucursales"
            }
          >
            <Article_six_functions_pos />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl +
              "/blog/solucion-de-comercio-electronico-personalizada"
            }
          >
            <Article_custom_email_solution />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl +
              "/blog/los-datos-de-su-punto-de-venta-son-una-mina-de-oro"
            }
          >
            <Article_data_pos />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl +
              "/blog/siete-habilidades-esenciales-para-la-gestion-de-restaurantes"
            }
          >
            <Article_seven_tips_managment_restaurants />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl +
              "/blog/cuatro-beneficios-de-los-pedidos-en-linea-para-propietarios-de-restaurantes"
            }
          >
            <Article_online_ordering />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl +
              "/blog/como-utilizar-el-video-marketing-para-promocionar-su-restaurante"
            }
          >
            <Article_marketing_restaurant />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl +
              "/blog/diez-industrias-donde-los-programas-de-lealtad-son-extremadamente-efectivos"
            }
          >
            <Article_ten_loyalty_industries />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl +
              "/blog/siete-beneficios-irresistibles-de-integrar-invupos-con-la-facturacion-electronica"
            }
          >
            <Article_seven_irresistible_benefits_invupos />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl +
              "/blog/facturador-gratuito-de-la-DGI-en-Panamá"
            }
          >
            <Article_DGI_free_invoicer_in_panama />
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/invupos-eleva-su-potencial-al-unirse-al-programa-nvidia-inception"
           }
          >
            <Article_nvidia_inception/>  
          </Route>
          
          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/gastronomia-con-sabor-a-tecnologia-transformando-restaurantes-en-mexico-con-invupos"
           }
          >
            <Article_restaurant_mexico_invupos/>  
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/maximizando-la-fidelizacion-de-los-clientes-con-invupos"
           }
          >
            <Article_maximizing_customer_loyalty/>  
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/invupos-anuncia-una-estrategica-alianza-con-cloudbeds"
           }
          >
            <Article_alliance_with_cloudbeds/>  
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/explorando-el-futuro-de-la-industria-de-restaurantes-en-2024"
           }
          >
            <Article_gastronomic_future/>  
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/gestion-inteligente-de-inventarios-en-la-industria-hotelera"
           }
          >
            <Article_management_inventory_hotel/>  
          </Route>


          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/estilo-en-la-nube-como-invupos-transforma-la-industria-de-la-moda"
           }
          >
            <Article_in_the_cloud/>  
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/software-pos-para-restaurantes-en-panama"
           }
          >
            <Article_exploring_restaurant_systems/>  
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/software-pos-para-restaurantes-en-mexico"
           }
          >
            <Article_software_for_restaurants_mx/>  
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/software-pos-para-restaurantes-en-el-salvador"
           }
          >
            <Article_software_for_restaurants_sv/>  
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/pasos-para-implementar-la-facturacion-electronica-en-panama"
           }
          >
            <Article_steps_to_implement_electronic_invoicing/>  
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/como-integrar-tu-sistema-pos-con-plataformas-de-delivery-en-el-salvador"
           }
          >
            <Article_how_to_integrate_your_pos_system/>  
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/sistema-pos-y-plataformas-de-delivery-en-venezuela"
           }
          >
            <Article_system_pos_and_delivery_platform_vn/>  
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/mejor-software-pos-para-restaurantes-en-panama"
           }
          >
            <Article_best_softwarepos_for_retaurants_in_panama/>  
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/software-pos-para-restaurantes-en-costarica"
           }
          >
            <Article_software_for_restaurants_cr/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/software-pos-para-restaurantes-en-colombia"
           }
          >
            <Article_software_for_restaurants_cl/>
          </Route>


          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/como-optimizar-tu-sistema-pos-para-un-servicio-inigualable"
           }
          >
            <Article_optimize_your_pos_system_for_unmatched_service/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/optimizando-la-cadena-de-suministros"
           }
          >
            <Article_optimizing_the_supply_chain/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/cinco-razones-para-tener-un-software-POS-en-tu-negocio"
           }
          >
            <Article_five_reasons_to_have_pos_cl/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/impulsando-la-rentabilidad-de-tu-restaurante-con-el-sistema-pos"
           }
          >
            <Article_boosting_profitability_restaurant_pos_vn/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/simplifica-la-facturacion-y-el-proceso-de-pago-como-invupos-agiliza-las-transacciones"
           }
          >
            <Article_simplify_billing_and_payment_process/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/por-que-elegir-un-sistema-pos-en-la-nube-la-mejor-opción-para-tu-negocio"
           }
          >
            <Article_why_choose_cloud_pos_system/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/sistemas-pos-personalizados-explorando-opciones-y-ventajas-competitivas"
           }
          >
            <Article_custom_pos_system_sv/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/como-mejorar-la-experiencia-del-cliente-y-aumentar-las-ventas"
           }
          >
            <Article_how_to_improve_customer_experience_mx/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/estrategias-para-aumentar-las-ventas-con-un-sistema-pos-en-tu-bar"
           }
          >
            <Article_strategies_to_increase_sales_all/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/el-futuro-del-cafe-tendencias-tecnologicas-que-debes-conocer-en-la-industria-cafetera"
           }
          >
            <Article_the_future_of_coffee/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/del-pedido-a-la-mesa-como-los-sistemas-kds-agilizan-el-flujo-de-trabajo-en-la-oficina"
           }
          >
            <Article_how_kds_systems_streamline/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/optimizando-tu-cocina-con-un-kds-consejos-y-trucos-de-un-chef"
           }
          >
            <Article_tips_and_tricks_from_a_chef/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/cinco-razones-por-las-que-tu-restaurante-necesita-una-pagina-web-moderna"
           }
          >
            <Article_five_reasons_why_restaurant_needs_modern_web/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/como-mejorar-la-experiencia-del-cliente-con-tecnologia-en-tu-bar"
           }
          >
            <Article_how_to_improve_the_customer_experience_in_bar/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/como-un-sistema-pos-puede-ayudar-a-impulsar-las-ventas-en-el-restaurante-del-hotel"
           }
          >
            <Article_how_pos_system_can_help_boost_hotel_rest_sales/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/descubre-donde-comprar-los-mejores-utensilios-para-un-chef"
           }
          >
            <Article_best_utensils_for_a_chef/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/la-importancia-de-un-sistema-pos-en-los-festivales-optimizando-la-experiencia-del-cliente-y-la-gestion-del-evento"
           }
          >
            <Article_importance_pos_system_event_management/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/los-beneficios-del-delivery-online"
           }
          >
            <Article_the_benefits_of_online_delivery/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/guia-para-restaurantes-en-panama-como-elegir-el-mejor-sistema-pos-para-tu-negocio"
           }
          >
            <Article_guide_for_restaurants_in_panama/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/como-un-sistema-pos-y-control-de-inventario-efectivos-pueden-hacer-la-diferencia"
           }
          >
            <Article_how_an_effective_pos/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/guia-completa-por-elegir-el-mejor-sistema-pos-para-tu-cafeteria"
           }
          >
            <Article_complete_guide_for_your_coffeeshop/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/marketing-digital-para-barberias-estrategias-para-atraer-y-retener-clientes"
           }
          >
            <Article_marketing_digital_for_barbers/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/como-elegir-el-mejor-sistema-pos-para-tu-estudio-de-tatuajes-una-guia-completa"
           }
          >
            <Article_pos_system_tattoo_studio/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/invupos-anuncia-nueva-integracion-con-hero-para-mejorar-la-contabilidad-y-gestion-financiera-de-sus-clientes"
           }
          >
            <Article_hero_integration/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/el-mejor-sistema-pos-para-spas-y-salones-de-belleza"
           }
          >
            <Article_bestpos_system_spas_beautysalons/>
          </Route>


          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/como-elegir-el-mejor-sistema-pos-para-tu-cerveceria-artesanal"
           }
          >
            <Article_choose_the_best_system_craft_brewery/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/como-los-gift-cards-pueden-impulsar-las-ventas-en-tu-salon-de-belleza"
           }
          >
            <Article_gift_cards_beatuy_salons/>
          </Route>


          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/simplifica-tu-food-truck-con-un-sistema-de-punto-de-venta-todo-en-uno"
           }
          >
            <Article_food_truck/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/anunciamos-nuestra-participacion-en-abastur-mexico-2024"
           }
          >
            <Article_abastur_mexico/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/las-wallets-digitales-y-sus-beneficios-para-tu-restaurante"
           }
          >
            <Article_digital_wallets_for_restaurants/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/beneficios-de-implementar-un-software-pos-en-restaurantes-de-el-salvador"
           }
          >
            <Article_implementation_pos_software_in_rest_salvador/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/como-un-sistema-pos-ayuda-a-mejorar-la-productividad-del-personal-en-el-comercio-salvadoreño"
           }
          >
            <Article_how_pos_system_helps_to_improve_staff_productivity_in_salvadoran_commerce/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/la-digitalizacion-del-comercio-en-colombia-el-rol-del-software-pos"
           }
          >
            <Article_the_digitization_of_commmerce_in_cl/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/beneficios-de-integrar-un-sistema-pos-con-programas-de-lealtad-en-tiendas-y-restaurantes-de-costa-rica"
           }
          >
            <Article_benefits_of_integrating_pos_programs_in_cr/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/cinco-razones-por-las-que-los-restaurantes-en-panama-estan-migrando-a-sistemas-pos-modernos"
           }
          >
            <Article_five_reasons_why_rest_in_panama_migrating/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/cinco-razones-por-las-que-los-restaurantes-en-mexico-estan-migrando-a-sistemas-pos-modernos"
           }
          >
            <Article_five_reasons_why_rest_in_mexico_migrating/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/como-los-sistemas-pos-facilitan-la-gestion-de-inventario-y-ventas"
           }
          >
            <Article_how_pos_systems_make_inventory_and_sales_easier/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/por-que-los-restaurantes-en-mexico-estan-adoptando-el-pos-en-la-nube"
           }
          >
            <Article_Why_are_restaurants_in_mx_adopting_cloud_pos/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/mejora-la-gestion-de-tu-restaurante-en-colombia"
           }
          >
            <Article_improve_the_management_of_your_rest_in_cl/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/como-un-sistema-pos-en-la-nube-facilita-la-expansion-de-resturantes-en-costa-rica"
           }
          >
            <Article_how_cloud_pos_system_facilities_rest_in_cr/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/como-un-sistema-pos-ayuda-a-gestionar-costos-en-restaurantes"
           }
          >
            <Article_how_pos_system_helps_manage_costs_in_rest_vn/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/siete-formas-de-impulsar-los-ingresos-de-un-hotel"
           }
          >
            <Article_seven_ways_to_boost_hotel_revenues/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/aumentar-ingresos-con-las-integraciones-de-delivery-de-invu-pos"
           }
          >
            <Article_increase_revenue_with_invupos_delivery_integrations/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/el-software-ideal-para-los-restaurantes-en-el-salvador"
           }
          >
            <Article_the_ideal_software_for_rest_in_sv/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/integraciones-clave-para-restaurantes-en-el-salvador"
           }
          >
            <Article_integrations_for_rest_in_sv/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/la-revolucion-digital-para-restaurantes-en-colombia"
           }
          >
            <Article_the_digital_revolution_for_rest_in_cl/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/la-clave-para-un-fin-de-año-exitoso"
           }
          >
            <Article_key_to_a_successful_new_year/>
          </Route>

          <Route
           exact
           path={
             baseRouteUrl +
             "/blog/aumenta-tus-ventas-con-invu-pos-en-el-salvador"
           }
          >
            <Article_increase_your_sale_with_invu_in_sv/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/invu-pos-el-software-elegido-por-imin-para-el-nrf-2025"
          }
          >
            <Article_invupos_the_software_chosen_by_imin_for_the_nrf/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/optimiza-tus-ventas-en-linea"
          }
          >
            <Article_optimize_your_online_sales/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-los-programas-de-lealtad-pueden-aumentar-tus-ventas"
          }
          >
            <Article_how_loyalty_programs_can_increase_your_sales_mx/>
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/la-importancia-de-un-sistema-pos-para-el-control-de-comandas-en-un-restaurante"
          }
          >
            <Article_the_importance_of_a_pos_systems_for_controlling_orders/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/la-evolucion-de-los-sistemas-pos-en-colombia-de-la-caja-registradora-al-software-inteligente"
          }
          >
            <Article_the_evolution_of_pos_systems_in_colombia/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-un-sistema-pos-revoluciona-la-operacion-de-los-food-trucks"
          }
          >
            <Article_how_a_revolutionary_POS_system_operates_foodtrucks/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/automatizacion-en-restaurantes-como-optimizar-pedidos-inventario-y-pagos-con-tecnologia"
          }
          >
            <Article_rest_automations_how_to_optimize_orders_inventory_and_payments_with_technology/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/la-facturacion-electronica-en-el-salvador"
          }
          >
            <Article_electronic_billing_in_el_salvador/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/optimiza-tu-food-truck-en-colombia"
          }
          >
            <Artilcle_optimize_your_food_truck_in_colombia/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/cinco-formas-en-las-que-un-pos-en-la-nube-mejora-la-experiencia-del-cliente"
          }
          >
            <Article_five_ways_a_cloud_pos_improves_the_customer_experience/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/testblog/details"
          }
          >
            <Testblog/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/haz-que-tu-restaurante-en-guatemala-venda-mas-con-un-pos-moderno"
          }
          >
            <Article_make_your_restaurant_in_guatemala_sell_more_with_a_modern_POS/>
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/kds-incorporado-con-pos-la-clave-para-una-cocina-eficiente"
          }
          >
            <Article_KDS_incorporated_with_POS/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-evitar-errores-en-los-pedidos-de-delivery-con-un-pos-inteligente"
          }
          >
            <Article_how_to_avoid_errors_in_delivery_orders_with_a_smart_POS/>
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-elegir-el-mejor-sistema-de-facturacion-electronica-para-tu-negocio-en-panama"
          }
          >
            <Article_choose_the_best_electronic_invoicing_system_for_your_business_in_panama/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/beneficios-de-un-sistema-pos-para-la-gestion-de-inventarios-en-retail-en-colombia"
          }
          >
            <Article_benefits_of_a_POS_system_for_retail_inventory_management_in_colombia/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/por-que-modernizar-tu-sistema-pos-es-la-clave-para-el-exito-de-tu-restaurante-en-costa-rica"
          }
          >
            <Article_upgrading_your_pos_syst_is_key_to_key_to_the_success_of_your_rest_cr/>
          </Route>



          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/el-ritmo-del-bar-no-espera-como-un-pos-agil-mejora-la-atencion-en-hora-pico"
          }
          >
            <Article_how_an_agile_POS_improves_improves_rush_hour_service/>
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/el-ritmo-del-bar-no-espera-como-un-pos-agil-mejora-la-atencion-en-hora-pico"
          }
          >
            <Article_how_an_agile_POS_improves_improves_rush_hour_service/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/mas-propinas-menos-problemas-por-que-tu-restaurante-en-colombia-necesita-un-pos-con-division-de-cuentas"
          }
          >
            <Article_more_tips_less_problems/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/sistema-pos-para-hoteles-en-costa-rica-optimiza-tu-operacion-desde-el-desayuno-hasta-el-checkout"
          }
          >
            <Article_POS_system_for_hotels_in_costa_rica/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/invu-pos-celebra-multiples-reconocimientos-internacionales-como-mejor-software-mejor-soporte-tecnico-mejor-app-y-liderazgo-en-la-industria"
          }
          >
            <Article_invu_reconocimientos/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/el-mejor-sistema-de-punto-de-venta-para-supermercados-en-el-salvador-precision-velocidad-y-control"
          }
          >
            <Article_the_best_point_of_sale_system_for_supermarkets_in_el_salvador/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/descubre-las-nuevas-novedades-de-invu-pos"
          }
          >
            <Article_invu_pos_novedades/> 
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/checklist-para-saber-si-tu-restaurante-necesita-cambiar-su-sistema-pos-hoy-mismo"
          }
          >
            <Article_checklist_to_determine_if_your_restaurant_needs_to_upgrade_its_POS_system/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/por-que-los-negocios-en-mexico-estan-apostando-por-programas-de-lealtad-digital"
          }
          >
            <Article_why_are_businesses_in_mx_betting_on_loyalty_programs_digital/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/lealtad-en-la-era-digital-como-los-restaurantes-en-colombia-estan-creando-conexiones-duraderas-con-sus-clientes"
          }
          >
            <Article_loyalty_in_the_digital_age/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/vale-la-pena-invertir-en-un-sistema-kds-comparativa-con-comandas-tradicionales"
          }
          >
            <Article_KDS_system_worth_investing_in/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/esta-tu-restaurante-o-tienda-lista-para-2025-todo-lo-que-debes-saber-sobre-la-facturacion-electronica-en-republica-dominicana"
          }
          >
            <Article_electronic_invoicing_in_the_dominican_republic/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/fideliza-mas-vende-mejor-como-un-sistema-pos-con-fidelizacion-de-clientes-impulsa-tu-negocio-en-costa-rica"
          }
          >
            <Article_loyalty_boosts_your_business_in_costa_rica/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/mejor-software-pos-para-restaurantes-en-republica-dominicana"
          }
          >
            <Article_best_POS_software_for_restaurants_rd/>
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/evita-multas-y-sanciones-anticipate-a-la-facturacion-electronica-en-el-salvador"
          }
          >
            <Article_avoid_fines_and_penalties_sv/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/delivery-lealtad-y-promociones-asi-venden-mas-los-restaurantes-que-usan-invu-pos-en-venezuela"
          }
          >
            <Article_delivery_promociones_lealtad_vn/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/delivery-lealtad-y-promociones-asi-venden-mas-los-restaurantes-que-usan-invu-pos-en-venezuela"
          }
          >
            <Article_delivery_promociones_lealtad_vn/>
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/errores-comunes-en-la-gestion-de-cafeterias-y-como-evitarlos-con-invu-pos"
          }
          >
            <Article_errores_comunes_en_la_gestion_de_cafeterias/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/control-total-de-tus-sucursales-en-mexico-con-invupos-ventas-inventario-y-operación-desde-un-solo-lugar"
          }
          >
            <Article_control_total_de_tus_sucursales_en_mx/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/control-total-de-tus-sucursales-en-panama-con-invupos-ventas-inventario-y-operación-desde-un-solo-lugar"
          }
          >
            <Article_complete_control_of_your_branches_in_panama_with_invu_POS/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/por-que-tu-cocina-en-colombia-necesita-un-kds-moderno-mas-velocidad-menos-errores-y-mejor-servicio"
          }
          >
            <Article_why_your_kitchen_in_colombia_needs_a_KDS/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/invu-pos-conquista-latinoamerica-y-los-premios-2025"
          }
          >
            <Article_invu_POS_conquers_latin_america_and_the_2025_awards/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/la-clave-para-escalar-tu-comercio-en-el-salvador"
          }
          >
            <Article_the_key_to_scale_your_commerce_in_sv/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/eres-dueño-o-gerente-de-hotel-esta-integracion-entre-invupos-y-cloudbeds-puede-transformar-tu-operacion"
          }
          >
            <Article_eres_dueño_o_gerente_de_hotel/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-un-buen-sistema-pos-impulsa-el-crecimiento-de-tu-negocio-en-costa-rica"
          }
          >
            <Article_como_un_buen_sistema_POS_impulsa_el_crecimiento_de_tu_negocio_en_cr/>
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/delivery-takeout-o-en-mesa-invu-pos-lo-centraliza-todo-en-un-solo-lugar"
          }
          >
            <Article_delivery_takeout_or_dine_in/>
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/velocidad-y-precision-el-secreto-de-los-restaurantes-en-mexico-que-usan-kds"
          }
          >
            <Article_speed_and_accuracy_the_secret_of_restaurants_in_mx/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/cinco-estrategias-para-aumentar-ventas-usando-programas-de-lealtad-digital-en-colombia"
          }
          >
            <Article_loyalty_sales_strategies_co/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-invu-pos-esta-transformando-la-experiencia-en-cafeterias-en-panama"
          }
          >
            <Article_como_invu_POS_esta_transformando_la_experiencia_en_cafeterias_en_panama/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/invu-pos-anuncia-su-participacion-en-abastur-2025-la-feria-lider-de-hospitalidad-en-latinoamerica"
          }
          >
            <Article_invupos_anuncia_participacion_abastur_2025/>
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/integraciones-que-potencian-tu-negocio-en-el-salvador-delivery-bancos-y-mas"
          }
          >
            <Article_integraciones_que_potencian_tu_negocio_en_el_salvador/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/invupos-participa-en-abastur-2025-junto-a-landi-sunmi-nextep-digitalpos"
          }
          >
            <Article_invupos_participa_en_el_abastur_2025/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/hoteles-inteligentes-en-republica-dominicana-como-un-pos-transforma-la-experiencia-del-huesped"
          }
          >
            <Article_hoteles_inteligentes_en_republica_dominicana_como_un_pos_transforma_la_experiencia_del_huesped/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/cinco-formas-en-que-la-facturacion-digital-con-invu-pos-mantiene-tu-negocio-en-orden"
          }
          >
            <Article_5_formas_en_que_la_facturacion_digital_con_invu_pos_mantiene_tu_negocio_en_orden/>
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/delivery-en-colombia-como-los-restaurantes-pueden-gestionarlo-de-forma-mas-eficiente-con-invu-pos"
          }
          >
            <Article_Delivery_en_Colombia_como_los_restaurantes_pueden_gestionarlo_de_forma_mas_eficiente_con_Invu_POS/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-transformar-tu-restaurante-en-un-ecommerce-rentable-con-invu-pos"
          }
          >
            <Article_como_transformar_tu_restaurante_en_un_ecommerce_rentable_con_invu/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/integraciones-que-impulsan-tu-restaurante-delivery-bancos-y-ecommerce-desde-un-solo-sistema"
          }
          >
            <Article_Integraciones_que_impulsan_tu_restaurante_delivery_bancos_y_ecommerce_desde_un_solo_sistema/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/diez-formas-en-que-un-buen-sistema-pos-transforma-la-eficiencia-de-tu-restaurante"
          }
          >
            <Article_diez_formas_en_que_un_buen_sistema_POS_transforma_la_eficiencia_de_tu_restaurante/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/que-tan-rentable-es-tu-restaurante-descubre-los-numeros-que-realmente-importan"
          }
          >
            <Article_que_tan_rentable_es_tu_restaurante_descubre_los_numeros_que_realmente_importan/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/el-caos-de-fin-de-ano-en-los-restaurantes-como-mantener-el-control-con-invu-pos"
          }
          >
            <Article_el_caos_de_fin_de_ano_en_los_restaurantes_como_mantener_el_control_con_invu_pos/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/el-caos-en-la-cocina-no-es-una-opcion-por-que-un-buen-kds-puede-cambiar-tu-cierre-de-ano"
          }
          >
            <Article_el_caos_en_la_cocina_no_es_una_opcion_por_que_un_buen_kds_puede_cambiar_tu_cierre_de_ano />
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-el-programa-de-lealtad-de-invu-pos-impulsa-tus-ventas-en-navidad"
          }
          >
            <Article_como_el_programa_de_lealtad_de_invu_pos_impulsa_tus_ventas_en_navidad />
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-el-programa-de-lealtad-de-invu-pos-impulsa-tus-ventas-en-navidad"
          }
          >
            <Article_como_el_programa_de_lealtad_de_invu_pos_impulsa_tus_ventas_en_navidad />
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/convierte-la-epoca-mas-movida-del-ano-en-oportunidad-con-el-programa-de-lealtad-de-invu-pos"
          }
          >
            <Article_convierte_la_epoca_mas_movida_del_ano_en_oportunidad_con_el_programa_de_lealtad_de_invu_pos />
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/regalos-que-generan-ingresos-como-vender-giftcards-digitales-con-invu-pos-esta-navidad"
          }
          >
            <Article_regalos_que_generan_ingresos_como_vender_giftcards_digitales_con_Invu_POS_esta_navidad/>
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/cierre-de-ano-ventas-al-maximo-como-un-pos-inteligente-impulsa-tu-temporada-de-diciembre"
          }
          >
            <Article_cierre_de_ano_ventas_al_maximo_como_un_pos_inteligente_impulsa_tu_temporada_de_diciembre/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-preparar-tu-delivery-para-la-temporada-mas-movida-del-ano"
          }
          >
            <Article_como_preparar_tu_delivery_para_la_temporada_mas_movida_del_ano/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/control-de-mesas-y-kds-cuando-diciembre-pone-a-prueba-tu-restaurante"
          }
          >
            <Article_control_de_mesas_y_kds_cuando_diciembre_pone_a_prueba_tu_restaurante/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/cuentas-separadas-mesas-felices-el-secreto-para-sobrevivir-a-la-temporada-navidena"
          }
          >
            <Article_cuentas_separadas_mesas_felices_el_secreto_para_sobrevivir_a_la_temporada_navidena/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/enero-el-mes-perfecto-para-ordenar-tu-negocio-y-vender-mejor-con-un-pos-moderno"
          }
          >
            <Article_enero_el_mes_perfecto_para_ordenar_tu_negocio_y_vender_mejor_con_un_pos_moderno/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/tendencias-tecnologicas-restaurantes-comercios-latinoamerica-2026"
          }
          >
            <Article_tendencias_tecnologicas_restaurantes_comercios_latinoamerica_2026/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/el-futuro-de-los-restaurantes-y-comercios-en-republica-dominicana"
          }
          >
            <Article_el_futuro_de_los_restaurantes_y_comercios_en_republica_dominicana/>
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/el-futuro-del-comercio-en-peru-tecnologia-que-impulsa-restaurantes-y-retail"
          }
          >
            <Article_el_futuro_del_comercio_en_peru_tecnologia_que_impulsa_restaurantes_y_retail/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/uber-eats-invu-pos-panama-sistema-pos-restaurantes-delivery-ventas"
          }
          >
            <Article_invupos_mas_ubereats/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/las-integraciones-que-todo-restaurante-en-colombia-necesita-en-su-sistema-pos-para-ser-realmente-rentable"
          }
          >
            <Article_las_integraciones_que_todo_restaurante_en_colombia_necesita_en_su_sistema_pos_para_ser_realmente_rentable/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/programa-de-lealtad-para-cadenas-en-mexico-como-escalar-la-fidelizacion-en-multiples-sucursales-con-el-mejor-sistema-pos"
          }
          >
            <Article_programa_de_lealtad_para_cadenas_en_mexico_como_escalar_la_fidelizacion_en_multiples_sucursales_con_el_mejor_sistema_pos/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/cual-es-el-mejor-sistema-pos-en-peru-para-restaurantes-en-2026"
          }
          >
            <Article_cual_es_el_mejor_sistema_pos_en_peru_para_restaurantes_en_2026/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/facturacion-electronica-en-costa-rica-por-que-necesitas-un-sistema-pos-actualizado-en-2026"
          }
          >
            <Article_facturacion_electronica_en_costa_rica_por_que_necesitas_un_sistema_pos_actualizado_en_2026/>
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/invu-pos-confirma-su-participacion-en-expo-horeca-panama-2026-con-innovaciones-en-tecnologia-y-fidelizacion"
          }
          >
            <Article_expo_horeca_2026/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-reducir-perdidas-y-aumentar-ganancias-en-tu-restaurante-en-santo-domingo-con-un-sistema-pos"
          }
          >
            <Article_como_reducir_perdidas_y_aumentar_ganancias_en_tu_restaurante_en_santo_domingo_con_un_sistema_pos/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-aumentar-frecuencia-clientes-restaurante-sin-invertir-publicidad-punch-card-digital"
          }
          >
            <Article_como_aumentar_frecuencia_clientes_restaurante_sin_invertir_publicidad_punch_card_digital/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-aumentar-tus-ventas-en-republica-dominicana-con-un-sistema-pos-inteligente-en-2026"
          }
          >
            <Article_como_aumentar_tus_ventas_en_republica_dominicana_con_un_sistema_pos_inteligente_en_2026/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/mas-ventas-menos-caos-como-un-sistema-pos-puede-aumentar-la-rentabilidad-de-tu-restaurante-en-peru"
          }
          >
            <Article_MasVentasMenosCaosSistemaPOSRentabilidadRestaurantePeru/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-aumentar-tus-ventas-en-mexico-con-un-sistema-pos-inteligente"
          }
          >
          <Article_como_aumentar_ventas_mexico_sistema_pos_inteligente/>
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/tu-restaurante-esta-perdiendo-dinero-sin-saberlo-5-errores-que-un-sistema-pos-puede-resolver"
          }
          >
          <Article_tu_restaurante_perdiendo_dinero_errores_sistema_pos/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/facturacion-electronica-en-colombia-como-un-sistema-pos-puede-simplificar-tu-negocio-en-2026"
          }
          >
          <Article_facturacion_electronica_colombia_sistema_pos_2026/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/domicilios-sin-caos-en-panama-la-formula-para-gestionar-pedidos-sin-errores-en-tu-restaurante"
          }
          >
          <Article_domicilios_sin_caos_panama_gestion_pedidos_restaurante/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/por-que-tu-restaurante-en-peru-pierde-dinero-en-inventario-y-como-solucionarlo-con-un-sistema-pos"
          }
          >
          <Article_por_que_tu_restaurante_en_peru_pierde_dinero_en_inventario_y_como_solucionarlo_con_un_sistema_pos/>
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-integrar-delivery-cocina-y-caja-en-un-solo-sistema-pos-en-republica-dominicana"
          }
          >
          <Article_como_integrar_delivery_cocina_y_caja_en_un_solo_sistema_pos_en_republica_dominicana/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-un-sistema-pos-puede-transformar-una-cafeteria-en-colombia-beneficios-de-implementar-invu-pos"
          }
          >
          <Article_como_un_sistema_pos_puede_transformar_una_cafeteria_en_colombia_beneficios_de_implementar_invu_pos/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/cinco-errores-que-hacen-perder-dinero-a-un-restaurante-en-peru-y-como-evitarlos"
          }
          >
          <Article_cinco_errores_que_hacen_perder_dinero_a_un_restaurante_en_peru_y_como_evitarlos/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/el-secreto-de-los-restaurantes-que-mas-crecen-en-colombia-fidelizar-clientes"
          }
          >
          <Article_el_secreto_de_los_restaurantes_que_mas_crecen_en_colombia_fidelizar_clientes/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/facturacion-electronica-en-republica-dominicana-como-preparar-tu-negocio-para-una-gestion-mas-eficiente"
          }
          >
          <Article_facturacion_electronica_en_republica_dominicana_como_preparar_tu_negocio_para_una_gestion_mas_eficiente/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-reducir-las-perdidas-por-inventario-en-un-restaurante-en-el-salvador"
          }
          >
          <Article_como_reducir_las_perdidas_por_inventario_en_un_restaurante_en_el_salvador/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/los-beneficios-de-un-sistema-kds-para-restaurantes-con-alto-volumen-de-pedidos"
          }
          >
          <Article_los_beneficios_de_un_sistema_kds_para_restaurantes_con_alto_volumen_de_pedidos/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/5-errores-que-cometen-las-tiendas-retail-en-peru-al-administrar-su-inventario-y-como-un-software-pos-puede-evitarlos"
          }
          >
          <Article_5_errores_que_cometen_las_tiendas_retail_en_peru_al_administrar_su_inventario_y_como_un_software_pos_puede_evitarlos/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-aumentar-el-ticket-promedio-en-una-tienda-sin-subir-los-precios"
          }
          >
          <Article_como_aumentar_el_ticket_promedio_en_una_tienda_sin_subir_los_precios/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/las-tendencias-que-estan-transformando-las-cafeterias-en-panama-en-2026-tecnologia-experiencia-y-eficiencia"
          }
          >
          <Article_las_tendencias_que_estan_transformando_las_cafeterias_en_panama_en_2026_tecnologia_experiencia_y_eficiencia/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/por-que-cada-vez-mas-restaurantes-en-mexico-estan-cambiando-a-un-sistema-pos-en-la-nube"
          }
          >
          <Article_por_que_cada_vez_mas_restaurantes_en_mexico_estan_cambiando_a_un_sistema_pos_en_la_nube/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-controlar-el-inventario-de-un-restaurante-y-reducir-las-mermas-en-peru"
          }
          >
          <Article_como_controlar_el_inventario_de_un_restaurante_y_reducir_las_mermas_en_peru/>
          </Route>
          
          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/cuanto-le-cuesta-a-un-restaurante-colombiano-no-tener-control-de-su-inventario"
          }
          >
          <Article_cuanto_le_cuesta_a_un_restaurante_colombiano_no_tener_control_de_su_inventario/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/5-senales-de-que-tu-negocio-en-costa-rica-necesita-un-sistema-pos"
          }
          >
          <Article_5_senales_de_que_tu_negocio_en_costa_rica_necesita_un_sistema_pos/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/del-efectivo-a-yappy-como-los-comercios-en-panama-pueden-simplificar-sus-pagos"
          }
          >
          <Article_del_efectivo_a_yappy_como_los_comercios_en_panama_pueden_simplificar_sus_pagos />
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-gestionar-el-inventario-de-tu-negocio-en-venezuela-y-evitar-perdidas-de-ventas"
          }
          >
          <Article_como_gestionar_el_inventario_de_tu_negocio_en_venezuela_y_evitar_perdidas_de_ventas/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/7-estrategias-de-fidelizacion-que-pueden-aumentar-las-visitas-recurrentes-a-tu-negocio"
          }
          >
          <Article_7_estrategias_de_fidelizacion_que_pueden_aumentar_las_visitas_recurrentes_a_tu_negocio/>
          </Route>


          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-tener-el-control-de-tu-restaurante-aunque-no-estes-en-el-local"
          }
          >
          <Article_como_tener_el_control_de_tu_restaurante_aunque_no_estes_en_el_local/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/como-aumentar-la-rentabilidad-de-una-cafeteria-en-panama-sin-vender-mas-cafe"
          }
          >
          <Article_como_aumentar_la_rentabilidad_de_una_cafeteria_en_panama_sin_vender_mas_cafe/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/factura-electronica-para-restaurantes-en-colombia-guia-paso-a-paso"
          }
          >
          <Article_factura_electronica_para_restaurantes_en_colombia_guia_paso_a_paso/>
          </Route>

          <Route
          exact
          path={
            baseRouteUrl +
             "/blog/sistema-pos-republica-dominicana"
          }
          >
          <Article_sistema_pos_en_republica_dominicana_por_que_tu_negocio_necesita_una_plataforma_todo_integrado/>
          </Route>
          
          
          {/* <Route
            exact
            path={
              baseRouteUrl +
              "/blog/como-proteger-ganancias-en-restaurantes-con-tecnologia"
            }
          >
            <Article_protect_earning />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl +
              "/blog/importancia-de-usar-el-software-pos-con-sistema-de-lealtad"
            }
          >
            <Article_importance_software_loyalty />
          </Route>

          <Route
            exact
            path={
              baseRouteUrl +
              "/blog/sistema-pos-para-el-comercio-electronico-en-línea-y-fuera-de-linea"
            }
          >
            <Article_ecommerce_online_offline />
          </Route> */}

          {/* <Route
            path={"/zendesk"}
            component={() => {
              window.open("https://www.google.com", "_blank")?.focus();
              return history.back(-1);
            }}
          /> */}

          <Route component={PageNotFound} />


        </Switch>
{/* 
        {window.location.pathname === "/auth/login" ? null : <Footer /> &&
          window.location.pathname === "/auth/signup" ? null : (
          <Footer />
        )} */}

        {/* <Footer/> */}
        {/* {isFromMexico ? <FooterMX/> : <Footer/>} */}
        {/* {country === 'Mexico' ? <FooterMX /> : country === 'Venezuela' ? <FooterVN /> : <Footer />} */}
        {/* {country === 'Mexico' ? <FooterMX /> : country === 'Venezuela' ? <FooterVN /> : country === 'Salvador' ? <FooterSV /> : <Footer />} */}
        {compareCountry(country, 'Mexico') || compareCountry(country, 'mexico') ? <FooterMX country={country} handleCountryChange={handleCountryChange} /> :
          compareCountry(country, 'Venezuela') || compareCountry(country, 'venezuela') ? <FooterVN country={country} handleCountryChange={handleCountryChange} /> :
          compareCountry(country, 'Elsalvador') || compareCountry(country, 'elsalvador') ? <FooterSV country={country} handleCountryChange={handleCountryChange} /> :
          compareCountry(country, 'Costarica') || compareCountry(country, 'costarica') ? <FooterCR country={country} handleCountryChange={handleCountryChange} /> :
          compareCountry(country, 'Colombia') || compareCountry(country, 'colombia') ? <FooterCL country={country} handleCountryChange={handleCountryChange} /> :
          compareCountry(country, 'Guatemala') || compareCountry(country, 'guatemala') ? <FooterGT country={country} handleCountryChange={handleCountryChange} /> :
          compareCountry(country, 'Republicadominicana') || compareCountry(country, 'republicadominicana') ? <FooterRD country={country} handleCountryChange={handleCountryChange} /> :
          compareCountry(country, 'Unitedstates') || compareCountry(country, 'unitedstates') ? <FooterUSA country={country} handleCountryChange={handleCountryChange} /> :
          compareCountry(country, 'Trinidadytobago') || compareCountry(country, 'trinidadytobago') ? <FooterTRI country={country} handleCountryChange={handleCountryChange} /> :
          compareCountry(country, 'Peru') || compareCountry(country, 'peru') ? <FooterPE country={country} handleCountryChange={handleCountryChange} /> :
          <Footer country={country} handleCountryChange={handleCountryChange} />
        }
        <Cookie_policy/>
      </BrowserRouter>
    </>
  );
}

export default withRouter(App);

